// src/__generated__/types.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    referrerId\n    linkName\n    urls\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryAttributionFragment on DiscoveryAttribution {\n    content {\n      text\n      inlineContent {\n        ... on EGDSText {\n          text\n        }\n      }\n    }\n    showContent {\n      accessibility\n      icon {\n        id\n        description\n        size\n      }\n    }\n    closeContent {\n      accessibility\n      primary\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryMediaItemFragment on DiscoveryMediaItem {\n    media {\n      ...EGDSImageFragment\n    }\n    attribution {\n      ...DiscoveryAttributionFragment\n    }\n    impression {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryMediaGalleryFragment on DiscoveryMediaGallery {\n    carousel {\n      ...EGDSCarouselFragment\n    }\n    items {\n      ...DiscoveryMediaItemFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardMediaFragment on DiscoveryCardMedia {\n    ... on DiscoveryMediaItem {\n      ...DiscoveryMediaItemFragment\n    }\n    ... on DiscoveryMediaGallery {\n      ...DiscoveryMediaGalleryFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    id\n    description\n    size\n    spotLight\n    theme\n    title\n    token\n    withBackground\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryOverlayHeaderFragment on DiscoveryOverlay {\n    closeButton {\n      action {\n        accessibility\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    heading {\n      title {\n        accessibility\n        text\n      }\n      subTitle {\n        ... on EGDSPlainText {\n          text\n          accessibility\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryDisclaimerOverlayFragment on DiscoveryDisclaimerOverlay {\n    text\n    icon {\n      ...EGDSIconFragment\n    }\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    overlay {\n      analytics {\n        linkName\n        referrerId\n      }\n      ...DiscoveryOverlayHeaderFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ... on UIAction {\n        ... on UILinkAction {\n          accessibility\n          resource {\n            value\n          }\n          analytics {\n            ...ClientSideAnalyticsFragment\n          }\n          target\n        }\n      }\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryHeadingFragment on DiscoveryHeading {\n    highlight\n    highlightAccessibilityLabel\n    title\n    titleAccessibilityLabel\n    subTitle\n    subTitleAccessibilityLabel\n    featuredHeader\n    featuredHeaderAccessibilityLabel\n    link {\n      ...EGDSStandardLinkFragment\n    }\n    disclaimer {\n      ... on DiscoveryDisclaimer {\n        ...DiscoveryDisclaimerOverlayFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n    size\n    theme\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardBadgesHeadingFragment on DiscoveryCardBadges {\n    heading {\n      ...EGDSBadgeFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardBadgesPriceFragment on DiscoveryCardBadges {\n    price {\n      ...EGDSBadgeFragment\n    }\n    priceBadge {\n      badge {\n        ...EGDSBadgeFragment\n      }\n      action {\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardBadgesPriceFragment on DiscoveryCardBadges {\n    price {\n      ...EGDSBadgeFragment\n    }\n    priceBadge {\n      badge {\n        ...EGDSBadgeFragment\n      }\n      action {\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgesPriceAltButtonFragment on DiscoveryCardBadges {\n    priceButton {\n      ... on DiscoveryPrimaryAltButton {\n        button {\n          egdsElementId\n          icon {\n            ...EGDSIconFragment\n          }\n          primary\n          action {\n            ... on UILinkAction {\n              accessibility\n              analytics {\n                ...ClientSideAnalyticsFragment\n              }\n              resource {\n                value\n              }\n              target\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBulletedListFragment on EGDSBulletedList {\n    listItems {\n      ... on EGDSTextStandardListItem {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSNestedLevelOneListFragment on EGDSNestedLevelOneList {\n    items {\n      ... on EGDSNestedLevelOneIconListItem {\n        text\n        icon {\n          id\n        }\n      }\n    }\n    size\n    type\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    text\n    icon {\n      id\n    }\n    nestedLevelOneList {\n      ...EGDSNestedLevelOneListFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListFragment on EGDSTextIconList {\n    listItems {\n      ...EGDSTextIconListItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUnorderedListFragment on EGDSUnorderedList {\n    listItems {\n      ... on EGDSTextStandardListItem {\n        text\n      }\n      ... on EGDSTextIconListItem {\n        ...EGDSTextIconListItemFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment EnrichedDetailsListFragment on EnrichedDetailsList {\n    additionalDescription {\n      ... on EGDSText {\n        ...EGDSTextFragment\n      }\n      ... on EGDSText {\n        text\n      }\n    }\n    list {\n      ... on EGDSTextIconList {\n        ...EGDSTextIconListFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDetailsListFragment on DiscoveryDetailsList {\n    __typename\n    ...EGDSTextIconListFragment\n    ...EGDSUnorderedListFragment\n    ...EGDSPlainTextFragment\n    ...EGDSBulletedListFragment\n    ...EnrichedDetailsListFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSRatingFragment on ProductRatingSummary {\n    icon {\n      ...EGDSIconFragment\n    }\n    accessibilityLabel\n    primary\n    secondary\n    supportingMessages {\n      ... on EGDSPlainText {\n        text\n      }\n    }\n    theme\n  }\n\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUICardActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    resource {\n      value\n    }\n    target\n  }\n\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryPriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment LegacyPriceFragment on PropertyPrice {\n    ...DiscoveryPriceSummaryFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n      ...TripsSaveCarOfferAttributesFragment\n      ...TripsSavePackageAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    label\n    tooltip\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  fragment TripsSavePackageAttributesFragment on TripsSavePackageAttributes {\n    packageOfferId\n    sessionId\n  }\n\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryTripSaveItemFragment on TripsSaveItem {\n    ...TripsSaveItemFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment AdTransparencyFragment on AdTransparencyTrigger {\n    adTransparencyId\n    adTransparencyButton {\n      ...LodgingAdTransparencyButtonFragment\n    }\n    adTransparencyOverlaySkeleton {\n      ...LodgingTransparencyOverlaySkeletonFragment\n    }\n  }\n  fragment LodgingAdTransparencyButtonFragment on AdTransparencyButton {\n    primary\n    icon {\n      id\n    }\n  }\n  fragment LodgingTransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      ...TransparencyOverlayErrorFragment\n    }\n  }\n  fragment TransparencyOverlayErrorFragment on TransparencyOverlayError {\n    icon {\n      id\n      size\n    }\n    description\n    button {\n      primary\n    }\n    allowedRetryAttempts\n    exceededAttemptsMessage\n  }\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment AdBadgeFragment on DiscoveryCardBadges {\n    adBadge {\n      ...EGDSBadgeFragment\n      ...AdTransparencyFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardLocationFragment on DiscoveryCardLocation {\n    leadingIcon {\n      id\n    }\n    text {\n      ... on EGDSPlainText {\n        text\n        accessibility\n      }\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryStarRatingFragment on DiscoveryStarRating {\n    ... on EGDSIconRating {\n      accessibility\n      rating\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListItemFragment on EGDSSpannableListItem {\n    graphic {\n      ...UIGraphicFragment\n    }\n    subText\n    text {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListFragment on EGDSSpannableList {\n    items {\n      ...EGDSSpannableListItemFragment\n    }\n    listType\n  }\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUniquenessFragment on DiscoveryProductUniqueness {\n    background\n    details {\n      ...EGDSSpannableListFragment\n    }\n    title {\n      ...EGDSGraphicTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandedLabel\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    lines\n    expanded\n  }\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewSnippetFragment on DiscoveryReviewSnippet {\n    ... on DiscoveryExpandoText {\n      text\n      textControl {\n        ...EGDSExpandoPeekFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryCardFragment on GenericDiscoveryCard {\n    heading {\n      ...DiscoveryHeadingFragment\n    }\n    media {\n      ...DiscoveryCardMediaFragment\n    }\n    badges {\n      ...DiscoveryCardBadgesHeadingFragment\n      ...DiscoveryCardBadgesPriceFragment\n      ...EGDSBadgesPriceAltButtonFragment\n      ...AdBadgeFragment\n    }\n    rating {\n      ...EGDSRatingFragment\n    }\n    detailsList {\n      ...EGDSDetailsListFragment\n    }\n    legacyPrice {\n      ...LegacyPriceFragment\n    }\n    tripSaveItem {\n      ...DiscoveryTripSaveItemFragment\n    }\n    impression {\n      ...ClientSideAnalyticsFragment\n    }\n    render {\n      urls\n    }\n    cardAction {\n      ...EGDSUICardActionFragment\n    }\n    starRating {\n      ...DiscoveryStarRatingFragment\n    }\n    location {\n      ...DiscoveryCardLocationFragment\n    }\n    reviewSnippet {\n      ...ReviewSnippetFragment\n    }\n    uniqueness {\n      ...PropertyUniquenessFragment\n    }\n    closeCardAction {\n      accessibility\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n      icon {\n        ...EGDSIconFragment\n      }\n    }\n    id\n    seoEntityUrl\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment SponsoredContentBeaconsFragment on SponsoredContentBeacons {\n    renderBeacons\n    viewabilityBeacon\n  }\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryViewportItemsFragment on DiscoveryViewportItems {\n    large\n    medium\n    small\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryGridFragment on DiscoveryGrid {\n    columns {\n      ...DiscoveryViewportItemsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryListFragment on DiscoveryList {\n    id\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryGroupLayoutFragment on DiscoveryGroupLayout {\n    ...EGDSCarouselFragment\n    ...DiscoveryListFragment\n    ...DiscoveryGridFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryExpandoFragment on DiscoveryExpando {\n    expando {\n      ...EGDSExpandoPeekFragment\n    }\n    hideScrim\n    items {\n      ...DiscoveryViewportItemsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryWrapperFragment on DiscoveryWrapper {\n    ...DiscoveryExpandoFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryContainerFragment on DiscoveryContainer {\n    itemsLayout {\n      ...DiscoveryGroupLayoutFragment\n    }\n    wrapper {\n      ...DiscoveryWrapperFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryGroupContainerFragment on DiscoveryItemsGroup {\n    container {\n      ...EGDSCarouselFragment\n      ...DiscoveryContainerFragment\n    }\n    cards {\n      ...DiscoveryCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      ...EGDSIconFragment\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    actionLink: action {\n      __typename\n      analytics {\n        referrerId\n        linkName\n      }\n      ... on UILinkAction {\n        resource {\n          ... on HttpURI {\n            relativePath\n          }\n        }\n        target\n      }\n    }\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryFooterActionFragment on DiscoveryFooterAction {\n    ...EGDSSecondaryButtonFragment\n    ...EGDSStandardLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryFooterSectionFragment on DiscoveryFooterSection {\n    disclaimerText {\n      ...EGDSTextFragment\n    }\n    title {\n      ...EGDSTextFragment\n    }\n    subtitle {\n      ...EGDSTextFragment\n    }\n    action {\n      ...DiscoveryFooterActionFragment\n    }\n    alignment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryTextFragment on DiscoveryText {\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoverySlimCardActionFragment on DiscoverySlimCardAction {\n    ... on UILinkAction {\n      accessibility\n      resource {\n        value\n      }\n      cardActionAnalytics: analytics {\n        ...ClientSideAnalyticsFragment\n      }\n      target\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoverySlimCardFragment on DiscoverySlimCard {\n    action {\n      ...DiscoverySlimCardActionFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n    primary\n    rightIcon {\n      ...EGDSIconFragment\n    }\n    secondaries {\n      ...DiscoveryTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryFooterFragment on DiscoveryFooter {\n    ...DiscoveryFooterSectionFragment\n    ...DiscoverySlimCardFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment DiscoveryItemsGroupFragment on DiscoveryItemsGroup {\n    impression {\n      ...ClientSideAnalyticsFragment\n    }\n    heading {\n      ...DiscoveryHeadingFragment\n    }\n    ...DiscoveryGroupContainerFragment\n    footerLink {\n      ...EGDSStandardLinkFragment\n    }\n    seoStructuredData\n    footer {\n      ...DiscoveryFooterFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  query DiscoveryRecentActivitiesModuleQuery(\n    $regionId: String\n    $containerType: DiscoveryContainerType\n    $typeFilter: [RecentActivityType!]\n    $contentSize: DiscoveryCardContentSize!\n    $context: ContextInput!\n    $discoveryRecentActivityContext: DiscoveryRecentActivityContextInput!\n    $configurationId: String\n  ) {\n    recentActivitiesModule(\n      regionId: $regionId\n      containerType: $containerType\n      typeFilter: $typeFilter\n      contentSize: $contentSize\n      context: $context\n      discoveryRecentActivityContext: $discoveryRecentActivityContext\n      configurationId: $configurationId\n    ) {\n      ...DiscoveryItemsGroupFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
var DiscoveryCardContentSize = /* @__PURE__ */ function(DiscoveryCardContentSize4) {
    DiscoveryCardContentSize4["ABBREVIATED"] = "ABBREVIATED";
    DiscoveryCardContentSize4["FOUNDATION"] = "FOUNDATION";
    DiscoveryCardContentSize4["FOUNDATION_DETAILS_LIST"] = "FOUNDATION_DETAILS_LIST";
    DiscoveryCardContentSize4["LANDING"] = "LANDING";
    DiscoveryCardContentSize4["LONG_FORM"] = "LONG_FORM";
    DiscoveryCardContentSize4["LONG_FORM_FEATURED"] = "LONG_FORM_FEATURED";
    DiscoveryCardContentSize4["SHORT_FORM"] = "SHORT_FORM";
    DiscoveryCardContentSize4["SMART_LANDING"] = "SMART_LANDING";
    DiscoveryCardContentSize4["UBER_ABBREVIATED"] = "UBER_ABBREVIATED";
    DiscoveryCardContentSize4["UBER_ABBREVIATED_PRICE"] = "UBER_ABBREVIATED_PRICE";
    DiscoveryCardContentSize4["UBER_ABBREVIATED_RATING"] = "UBER_ABBREVIATED_RATING";
    return DiscoveryCardContentSize4;
}(DiscoveryCardContentSize || {});
var DiscoveryContainerType = /* @__PURE__ */ function(DiscoveryContainerType2) {
    DiscoveryContainerType2["CAROUSEL"] = "CAROUSEL";
    DiscoveryContainerType2["EXPANDO"] = "EXPANDO";
    DiscoveryContainerType2["GRID"] = "GRID";
    DiscoveryContainerType2["LIST"] = "LIST";
    return DiscoveryContainerType2;
}(DiscoveryContainerType || {});
var LineOfBusinessDomain = /* @__PURE__ */ function(LineOfBusinessDomain3) {
    LineOfBusinessDomain3["ACTIVITIES"] = "ACTIVITIES";
    LineOfBusinessDomain3["CAR"] = "CAR";
    LineOfBusinessDomain3["CRUISES"] = "CRUISES";
    LineOfBusinessDomain3["FLIGHT"] = "FLIGHT";
    LineOfBusinessDomain3["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
    LineOfBusinessDomain3["LODGING"] = "LODGING";
    LineOfBusinessDomain3["PACKAGES"] = "PACKAGES";
    LineOfBusinessDomain3["RAILS"] = "RAILS";
    LineOfBusinessDomain3["UNCLASSIFIED"] = "UNCLASSIFIED";
    return LineOfBusinessDomain3;
}(LineOfBusinessDomain || {});
var RecentActivityType = /* @__PURE__ */ function(RecentActivityType2) {
    RecentActivityType2["BROWSING_HISTORY"] = "BROWSING_HISTORY";
    RecentActivityType2["RECENT_SEARCHES"] = "RECENT_SEARCHES";
    RecentActivityType2["VIEWED_OFFERS"] = "VIEWED_OFFERS";
    RecentActivityType2["VIEWED_PRODUCTS"] = "VIEWED_PRODUCTS";
    return RecentActivityType2;
}(RecentActivityType || {});
// src/components/recent-activities-module/recent-activities-module.tsx
import React76 from "react";
import { gql as gql68, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/components/discovery-items-group/discovery-items-group.tsx
import React75 from "react";
import { gql as gql67 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker10 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/utils/analytics.ts
function sendTracking(analytics, track) {
    track(analytics.referrerId, analytics.linkName, void 0, getMicroMessages(analytics.uisPrimeMessages));
}
function getMicroMessages(uisPrimeMessages) {
    return uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.map(function(uisPrimeMessage) {
        return {
            messageContent: JSON.parse(uisPrimeMessage.messageContent),
            schemaName: uisPrimeMessage.schemaName
        };
    });
}
// ../internal/src/components/utils/fragments/client-side-analytics-fragments.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/discovery-group-container/discovery-group-container.tsx
import React67 from "react";
import { gql as gql58 } from "@apollo/client";
import { useViewportMap as useViewportMap2, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
// ../internal/src/components/utils/carousel-layout-options.ts
import { ViewSizes } from "@shared-ui/viewport-context";
var PeekSizes = {
    sm: "sm",
    md: "md",
    lg: "lg",
    xl: "xl"
};
var _obj;
var ViewSizesToPeekViewport = (_obj = {}, _define_property(_obj, ViewSizes.SMALL, PeekSizes.sm), _define_property(_obj, ViewSizes.MEDIUM, PeekSizes.md), _define_property(_obj, ViewSizes.LARGE, PeekSizes.lg), _define_property(_obj, ViewSizes.EXTRA_LARGE, PeekSizes.xl), _obj);
var transformToViewSizeToPeekMap = function(peekPerViewportMap) {
    return Object.keys(ViewSizes).reduce(function(acc, viewSize) {
        var peekValue = peekPerViewportMap[ViewSizesToPeekViewport[viewSize]];
        acc[viewSize] = peekValue === void 0 ? true : Boolean(peekValue);
        return acc;
    }, {});
};
var getViewSizesToPeekMap = function(peek) {
    return Object.keys(ViewSizes).reduce(function(acc, viewSize) {
        acc[viewSize] = peek;
        return acc;
    }, {});
};
var peekModifier = function(peek) {
    switch(typeof peek === "undefined" ? "undefined" : _type_of(peek)){
        case "boolean":
            return getViewSizesToPeekMap(peek);
        case "object":
            return transformToViewSizeToPeekMap(peek);
        default:
            return getViewSizesToPeekMap(true);
    }
};
var shallowOverride = function(original, overrides) {
    var result = {};
    Object.keys(original).forEach(function(key) {
        result[key] = _object_spread({}, original[key], overrides[key]);
    });
    return result;
};
// ../internal/src/components/cards/foundation-card.tsx
import React49 from "react";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView2 } from "react-intersection-observer";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// ../internal/src/components/discovery-card-media/discovery-card-media.tsx
import React6 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/discovery-card-media/discovery-media-gallery.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-carousel/egds-carousel.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { useInView } from "react-intersection-observer";
import { UitkCarousel } from "uitk-react-carousel";
var __fragment = gql2(_templateObject1());
var EGDSCarousel = function(param) {
    var data = param.data, children = param.children, peek = param.peek, itemsVisible = param.itemsVisible, _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? false : _param_enableTracking, _param_itemViewedCallback = param.itemViewedCallback, itemViewedCallback = _param_itemViewedCallback === void 0 ? null : _param_itemViewedCallback, _param_onIndexChange = param.onIndexChange, onIndexChange = _param_onIndexChange === void 0 ? null : _param_onIndexChange, _param_itemsMaxHeight = param.itemsMaxHeight, itemsMaxHeight = _param_itemsMaxHeight === void 0 ? false : _param_itemsMaxHeight, _param_pagingInset = param.pagingInset, pagingInset = _param_pagingInset === void 0 ? false : _param_pagingInset, _param_pagingOverlay = param.pagingOverlay, pagingOverlay = _param_pagingOverlay === void 0 ? false : _param_pagingOverlay, _param_pagingPersistent = param.pagingPersistent, pagingPersistent = _param_pagingPersistent === void 0 ? true : _param_pagingPersistent, _param_loop = param.loop, loop = _param_loop === void 0 ? false : _param_loop, navigationIconId = param.navigationIconId, className = param.className, _param_hideNav = param.hideNav, hideNav = _param_hideNav === void 0 ? false : _param_hideNav;
    var nextButton = data.nextButton, previousButton = data.previousButton;
    var carouselRef = React.useRef(null);
    var trackerEvent = useClickTracker();
    var lastIndex = React.useRef(0);
    var isFirstRender = React.useRef(true);
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var _useInView = useInView({
        triggerOnce: true,
        threshold: 0.9
    }), ref = _useInView.ref, inView = _useInView.inView;
    var propertiesToShow = React.useMemo(function() {
        switch(viewSize){
            case defaultViewSizes.SMALL:
                {
                    return itemsVisible.sm;
                }
            case defaultViewSizes.MEDIUM:
                {
                    return itemsVisible.md;
                }
            case defaultViewSizes.LARGE:
                {
                    return itemsVisible.lg;
                }
            default:
                var _itemsVisible_xl;
                return (_itemsVisible_xl = itemsVisible.xl) !== null && _itemsVisible_xl !== void 0 ? _itemsVisible_xl : 4;
        }
    }, [
        viewSize,
        itemsVisible
    ]);
    var onIndexChangeCallback = React.useCallback(function(index) {
        var _button_analytics;
        var button = index >= lastIndex.current ? nextButton : previousButton;
        if ((button === null || button === void 0 ? void 0 : (_button_analytics = button.analytics) === null || _button_analytics === void 0 ? void 0 : _button_analytics.referrerId) && enableTracking && !isFirstRender.current) {
            var _button_analytics_linkName;
            trackerEvent(button.analytics.referrerId, (_button_analytics_linkName = button.analytics.linkName) !== null && _button_analytics_linkName !== void 0 ? _button_analytics_linkName : "");
        }
        if (inView) {
            onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(index);
        }
        lastIndex.current = index;
    }, [
        nextButton,
        previousButton,
        lastIndex,
        trackerEvent,
        propertiesToShow,
        enableTracking,
        inView
    ]);
    React.useEffect(function() {
        if (inView) {
            onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(lastIndex.current);
            isFirstRender.current = false;
        }
    }, [
        inView,
        lastIndex.current
    ]);
    var _nextButton_accessibility, _previousButton_accessibility;
    return /* @__PURE__ */ React.createElement(UitkCarousel, {
        buttonText: {
            nextButton: (_nextButton_accessibility = nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) !== null && _nextButton_accessibility !== void 0 ? _nextButton_accessibility : "",
            prevButton: (_previousButton_accessibility = previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) !== null && _previousButton_accessibility !== void 0 ? _previousButton_accessibility : ""
        },
        navigationIconId: navigationIconId,
        itemsVisible: itemsVisible,
        pageBy: 1,
        pagingPersistent: pagingPersistent,
        peek: peek,
        itemViewedCallback: itemViewedCallback,
        itemsMaxHeight: itemsMaxHeight,
        pagingInset: pagingInset,
        pagingOverlay: pagingOverlay,
        className: className,
        loop: loop,
        carouselRef: carouselRef,
        onIndexChange: onIndexChangeCallback,
        domRef: ref,
        hideNav: hideNav
    }, children);
};
EGDSCarousel.fragment = __fragment;
EGDSCarousel.displayName = "EGDSCarousel";
// ../internal/src/components/discovery-card-media/discovery-media-item.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
// ../internal/src/components/egds-image/egds-image.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/components/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj1;
var aspectRatioMapper = (_obj1 = {}, _define_property(_obj1, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj1, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _define_property(_obj1, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj1, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj1, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj1, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj1, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _obj1);
// ../internal/src/components/egds-image/egds-image.tsx
var __fragment2 = gql3(_templateObject2());
var isImgCached = function(url) {
    if (!sessionStorage.getItem(url)) {
        sessionStorage.setItem(url, true.toString());
        return false;
    }
    return true;
};
var EGDSImage = function(param) {
    var figureProps = param.figureProps, data = param.data, _param_lazyLoad = param.lazyLoad, lazyLoad = _param_lazyLoad === void 0 ? "off" : _param_lazyLoad, _param_link = param.link, link = _param_link === void 0 ? {} : _param_link, _param_enableImgLoadingState = param.enableImgLoadingState, enableImgLoadingState = _param_enableImgLoadingState === void 0 ? false : _param_enableImgLoadingState;
    var _ref = figureProps !== null && figureProps !== void 0 ? figureProps : {}, roundcorner = _ref.roundcorner, _ref_ratio = _ref.ratio, ratio = _ref_ratio === void 0 ? UitkFigureAspectRatioType2.R21_9 : _ref_ratio, imageFit = _ref.imageFit;
    var _ref1 = link || {}, resource = _ref1.resource, target = _ref1.target, analytics = _ref1.analytics, accessibility = _ref1.accessibility;
    var clickTracker = useClickTracker2();
    var imgRef = React2.useRef(null);
    var aspectRatio = data.aspectRatio ? aspectRatioMapper[data.aspectRatio] : ratio;
    var navigationTarget = link.target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var onClick = React2.useCallback(function() {
        if ((analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) && (analytics === null || analytics === void 0 ? void 0 : analytics.linkName)) {
            sendTracking(analytics, clickTracker);
        }
    }, [
        clickTracker
    ]);
    var loadImage = React2.useCallback(function() {
        if (enableImgLoadingState && imgRef.current) {
            imgRef.current.style.opacity = "1";
        }
    }, []);
    if (enableImgLoadingState && imgRef.current && !isImgCached(data.url)) {
        imgRef.current.style.opacity = "0";
    }
    return (resource === null || resource === void 0 ? void 0 : resource.value) ? /* @__PURE__ */ React2.createElement("a", {
        target: navigationTarget,
        href: resource.value,
        rel: "noopener",
        onClickCapture: onClick
    }, /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: aspectRatio,
        roundcorner: roundcorner,
        imageFit: imageFit,
        className: "uitk-image-placeholder uitk-image-placeholder-image"
    }, accessibility && /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), /* @__PURE__ */ React2.createElement(UitkImage, {
        imgRef: imgRef,
        src: data.url,
        alt: data.description,
        placeholderImage: true,
        additionalProps: {
            onLoad: loadImage,
            decoding: "async"
        },
        lazyLoading: lazyLoad
    }))) : /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: aspectRatio,
        roundcorner: roundcorner,
        imageFit: imageFit
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        src: data.url,
        imgRef: imgRef,
        alt: data.description,
        placeholderImage: true,
        lazyLoading: lazyLoad
    }));
};
EGDSImage.fragment = __fragment2;
EGDSImage.displayName = "EGDSImage";
// ../internal/src/components/discovery-card-media/discovery-attribution.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkIcon, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSheetTransition } from "uitk-react-sheet";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/utils/uitk-icon-size-mapper.ts
import { UitkIconSize } from "uitk-react-icons";
var _obj2;
var iconSizeMapper = (_obj2 = {}, _define_property(_obj2, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _define_property(_obj2, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _define_property(_obj2, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _define_property(_obj2, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _define_property(_obj2, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _define_property(_obj2, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj2);
// ../internal/src/components/discovery-card-media/discovery-attribution.tsx
var __fragment3 = gql4(_templateObject3());
var DiscoveryAttribution = function(param) {
    var data = param.data;
    var content = data.content, showContent = data.showContent, closeContent = data.closeContent;
    var dialogKey = React3.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var _useDialog = _sliced_to_array(useDialog("discovery-image-attribution-info-".concat(dialogKey)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var handleClick = React3.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var _ref = (showContent === null || showContent === void 0 ? void 0 : showContent.icon) || {}, _ref_id = _ref.id, id = _ref_id === void 0 ? "info_outline" : _ref_id, _ref_description = _ref.description, description = _ref_description === void 0 ? "" : _ref_description, size = _ref.size;
    var _showContent_accessibility, _showContent_accessibility1, _closeContent_primary;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkLink, {
        onClick: handleClick,
        theme: "inverse",
        "aria-label": (_showContent_accessibility = showContent === null || showContent === void 0 ? void 0 : showContent.accessibility) !== null && _showContent_accessibility !== void 0 ? _showContent_accessibility : ""
    }, /* @__PURE__ */ React3.createElement("button", {
        type: "button",
        "aria-label": (_showContent_accessibility1 = showContent === null || showContent === void 0 ? void 0 : showContent.accessibility) !== null && _showContent_accessibility1 !== void 0 ? _showContent_accessibility1 : ""
    }, /* @__PURE__ */ React3.createElement(UitkIcon, {
        id: id,
        name: id,
        title: description,
        size: iconSizeMapper[size !== null && size !== void 0 ? size : UitkIconSize2.SMALL]
    }))), /* @__PURE__ */ React3.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React3.createElement(DialogComponent, null, /* @__PURE__ */ React3.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React3.createElement(UitkDialogContent, {
        key: "dialog"
    }, /* @__PURE__ */ React3.createElement(UitkText, {
        theme: "emphasis"
    }, content.text)), /* @__PURE__ */ React3.createElement(UitkDialogFooter, {
        key: "footer",
        "aria-label": (closeContent === null || closeContent === void 0 ? void 0 : closeContent.accessibility) || "",
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_closeContent_primary = closeContent === null || closeContent === void 0 ? void 0 : closeContent.primary) !== null && _closeContent_primary !== void 0 ? _closeContent_primary : "",
            type: "tertiary"
        }
    })))));
};
DiscoveryAttribution.fragment = __fragment3;
DiscoveryAttribution.displayName = "DiscoveryAttribution";
// ../internal/src/components/discovery-card-media/discovery-media-item.tsx
var __fragment4 = gql5(_templateObject4(), EGDSImage.fragment, DiscoveryAttribution.fragment, ClientSideAnalyticsFragment);
var DiscoveryMediaItem = function(param) {
    var data = param.data, figureProps = param.figureProps, _param_showAttribution = param.showAttribution, showAttribution = _param_showAttribution === void 0 ? true : _param_showAttribution, lazyLoad = param.lazyLoad, link = param.link, enableImgLoadingState = param.enableImgLoadingState, enableImpressionTracking = param.enableImpressionTracking;
    var attribution = data.attribution, media = data.media, impression = data.impression;
    var defaultImageMedia = {
        __typename: "Image",
        url: null,
        aspectRatio: null,
        description: ""
    };
    if (media && media.__typename !== "Image") {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "relative",
        cloneElement: !showAttribution
    }, /* @__PURE__ */ React4.createElement(EGDSImage, {
        data: media !== null && media !== void 0 ? media : defaultImageMedia,
        figureProps: figureProps,
        lazyLoad: lazyLoad,
        link: link,
        enableImgLoadingState: enableImgLoadingState
    }), showAttribution && attribution && (media === null || media === void 0 ? void 0 : media.url) && /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            bottom: "three",
            right: "three",
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React4.createElement(DiscoveryAttribution, {
        data: attribution
    })), /* @__PURE__ */ React4.createElement(UitkScrim, {
        type: UitkScrimType.BOTTOM
    })));
};
DiscoveryMediaItem.fragment = __fragment4;
DiscoveryMediaItem.displayName = "DiscoveryMediaItem";
// ../internal/src/components/discovery-card-media/discovery-media-gallery.tsx
var __fragment5 = gql6(_templateObject5(), EGDSCarousel.fragment, DiscoveryMediaItem.fragment);
var DiscoveryMediaGallery = function(param) {
    var data = param.data, itemsVisible = param.itemsVisible, peek = param.peek, pagingOverlay = param.pagingOverlay, pagingInset = param.pagingInset, itemsMaxHeight = param.itemsMaxHeight, className = param.className, figureProps = param.figureProps, shouldLazyLoadImg = param.shouldLazyLoadImg, _param_loop = param.loop, loop = _param_loop === void 0 ? false : _param_loop, imageLink = param.imageLink, enableImgLoadingState = param.enableImgLoadingState;
    var track = useClickTracker3();
    var trackDiscoveryMediaItemImpression = React5.useCallback(function(index) {
        var _data_items_index, _data_items;
        if ((_data_items = data.items) === null || _data_items === void 0 ? void 0 : (_data_items_index = _data_items[index]) === null || _data_items_index === void 0 ? void 0 : _data_items_index.impression) {
            var _data_items_index1;
            var impression = (_data_items_index1 = data.items[index]) === null || _data_items_index1 === void 0 ? void 0 : _data_items_index1.impression;
            if (impression === null || impression === void 0 ? void 0 : impression.referrerId) {
                var linkName = impression.linkName, referrerId = impression.referrerId, uisPrimeMessages = impression.uisPrimeMessages;
                var microMessages = uisPrimeMessages.map(function(param) {
                    var messageContent = param.messageContent, schemaName = param.schemaName;
                    return {
                        messageContent: JSON.parse(messageContent),
                        schemaName: schemaName
                    };
                });
                track(referrerId, linkName, false, microMessages);
            }
        }
    }, []);
    if (data.items.length === 0) {
        return null;
    }
    if (data.carousel) {
        var randomNumber = Math.random().toString(36).slice(2, 5);
        return /* @__PURE__ */ React5.createElement(EGDSCarousel, {
            itemsVisible: itemsVisible,
            peek: peek,
            data: data.carousel,
            pagingInset: pagingInset,
            itemsMaxHeight: itemsMaxHeight,
            pagingOverlay: pagingOverlay,
            className: className,
            navigationIconId: {
                next: "next-button-".concat(randomNumber),
                prev: "prev-button-".concat(randomNumber)
            },
            loop: loop,
            enableTracking: true,
            onIndexChange: trackDiscoveryMediaItemImpression
        }, data.items.map(function(item, index) {
            return /* @__PURE__ */ React5.createElement(DiscoveryMediaItem, {
                data: item,
                key: index,
                figureProps: figureProps,
                lazyLoad: index === 0 && !shouldLazyLoadImg ? "off" : "lazy",
                link: imageLink,
                enableImgLoadingState: enableImgLoadingState
            });
        }));
    }
    return data.items[0] ? /* @__PURE__ */ React5.createElement(DiscoveryMediaItem, {
        data: data.items[0]
    }) : null;
};
DiscoveryMediaGallery.fragment = __fragment5;
DiscoveryMediaGallery.displayName = "DiscoveryMediaGallery";
// ../internal/src/components/discovery-card-media/discovery-card-media.tsx
var __fragment6 = gql7(_templateObject6(), DiscoveryMediaItem.fragment, DiscoveryMediaGallery.fragment);
var DiscoveryCardMedia = function(param) {
    var data = param.data, figureProps = param.figureProps, showAttribution = param.showAttribution, shouldLazyLoadImg = param.shouldLazyLoadImg, _param_carouselLoop = param.carouselLoop, carouselLoop = _param_carouselLoop === void 0 ? false : _param_carouselLoop, imageLink = param.imageLink, enableImgLoadingState = param.enableImgLoadingState;
    switch(data.__typename){
        case "DiscoveryMediaItem":
            return /* @__PURE__ */ React6.createElement(DiscoveryMediaItem, {
                data: data,
                figureProps: figureProps,
                showAttribution: showAttribution,
                lazyLoad: !shouldLazyLoadImg ? "off" : "lazy",
                enableImgLoadingState: enableImgLoadingState
            });
        case "DiscoveryMediaGallery":
            var _data_items;
            return /* @__PURE__ */ React6.createElement(DiscoveryMediaGallery, {
                data: data,
                itemsVisible: {
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1
                },
                peek: false,
                figureProps: figureProps,
                pagingInset: true,
                itemsMaxHeight: true,
                pagingOverlay: true,
                className: ((_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.length) > 1 ? "uitk-layout-position-zindex-layer2" : "",
                shouldLazyLoadImg: shouldLazyLoadImg,
                loop: carouselLoop,
                imageLink: imageLink,
                enableImgLoadingState: enableImgLoadingState
            });
        default:
            return null;
    }
};
DiscoveryCardMedia.fragment = __fragment6;
DiscoveryCardMedia.displayName = "DiscoveryCardMedia";
// ../internal/src/components/discovery-heading/discovery-heading.tsx
import React11 from "react";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/discovery-disclaimer-overlay/discovery-disclaimer-overlay.tsx
import React9 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSheet, UitkSheetContent, UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
import { UitkSpacing } from "uitk-react-spacing";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React7 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
var _obj3;
// ../internal/src/components/utils/icon-type-mapper.ts
var IconThemeToUitkIconThemeMap = (_obj3 = {}, _define_property(_obj3, "default" /* default */ , "default"), _define_property(_obj3, "emphasis" /* emphasis */ , "emphasis"), _define_property(_obj3, "negative" /* negative */ , "negative"), _define_property(_obj3, "positive" /* positive */ , "positive"), _define_property(_obj3, "inverse" /* inverse */ , "inverse"), _obj3);
// ../internal/src/components/egds-icon/egds-icon.tsx
var __fragment7 = gql8(_templateObject7());
var EGDSIcon = function(param) {
    var data = param.data, className = param.className, iconSizeOverride = param.iconSizeOverride;
    var uitkIconTheme = data.theme ? IconThemeToUitkIconThemeMap[data.theme] : void 0;
    var size = data.size ? UitkIconSize3[data.size] : UitkIconSize3.EXTRA_SMALL;
    var _data_title;
    return /* @__PURE__ */ React7.createElement(UitkIcon2, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: iconSizeOverride !== null && iconSizeOverride !== void 0 ? iconSizeOverride : size,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: uitkIconTheme,
        shadow: Boolean(data.withBackground)
    });
};
EGDSIcon.fragment = __fragment7;
EGDSIcon.displayName = "EGDSIcon";
// ../internal/src/components/discovery-disclaimer-overlay/discovery-overlay-header.tsx
import React8 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkToolbar } from "uitk-react-toolbar";
var __fragment8 = gql9(_templateObject8());
var DiscoveryOverlayHeader = function(param) {
    var data = param.data, closeDialog = param.closeDialog;
    var closeButton = data.closeButton, heading = data.heading;
    var _ref = (closeButton === null || closeButton === void 0 ? void 0 : closeButton.action) || {}, analytics = _ref.analytics, accessibility = _ref.accessibility;
    var clickTracker = useClickTracker4();
    var closeToolbar = React8.useCallback(function() {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
        closeDialog();
    }, [
        closeDialog
    ]);
    return /* @__PURE__ */ React8.createElement(UitkToolbar, {
        navigationContent: {
            onClick: closeToolbar,
            navType: "close"
        },
        "aria-label": accessibility || "",
        toolbarTitle: heading.title.text
    });
};
DiscoveryOverlayHeader.fragment = __fragment8;
DiscoveryOverlayHeader.displayName = "DiscoveryOverlayHeader";
// ../internal/src/components/discovery-disclaimer-overlay/discovery-disclaimer-overlay.tsx
var __fragment9 = gql10(_templateObject9(), ClientSideAnalyticsFragment, EGDSIcon.fragment, DiscoveryOverlayHeader.fragment);
var DiscoveryDisclaimerOverlay = function(param) {
    var data = param.data, children = param.children;
    var overlay = data.overlay, icon = data.icon, text = data.text, analytics = data.analytics, accessibility = data.accessibility;
    var isSmallViewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    }) === defaultViewSizes2.SMALL;
    var actionRef = React9.useRef(null);
    var clickTracker = useClickTracker5();
    var _ref = analytics || {}, referrerId = _ref.referrerId, _ref_linkName = _ref.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
    var _useDialog2 = _sliced_to_array(useDialog2("legal-disclaimer-overlay"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    if (!overlay) {
        return null;
    }
    var openDialog = function() {
        dialogActions.openDialog({
            closeAllDialogs: true
        });
    };
    var closeDialog = function() {
        dialogActions.closeDialog();
    };
    var openOverlay = function(event) {
        if (referrerId) {
            clickTracker(referrerId, linkName);
        }
        openDialog();
    };
    return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(UitkMoreInfoTrigger, {
        size: "small",
        onClick: openOverlay
    }, /* @__PURE__ */ React9.createElement("button", {
        type: "button"
    }, text, icon && /* @__PURE__ */ React9.createElement(EGDSIcon, {
        data: icon
    }))), /* @__PURE__ */ React9.createElement(UitkSheetTransition2, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React9.createElement(DialogComponent, null, /* @__PURE__ */ React9.createElement(UitkSheet, {
        type: isSmallViewSize ? "full" : "centered",
        isVisible: isDialogOpen,
        triggerRef: actionRef
    }, /* @__PURE__ */ React9.createElement(DiscoveryOverlayHeader, {
        data: overlay,
        closeDialog: closeDialog
    }), /* @__PURE__ */ React9.createElement(UitkSpacing, {
        padding: {
            blockstart: "three",
            inline: "six",
            blockend: "six"
        }
    }, /* @__PURE__ */ React9.createElement(UitkSheetContent, {
        padded: false
    }, children))))));
};
DiscoveryDisclaimerOverlay.fragment = __fragment9;
DiscoveryDisclaimerOverlay.displayName = "DiscoveryDisclaimerOverlay";
// ../internal/src/components/egds-standard-link/egds-standard-link.tsx
import React10 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText as UitkText2 } from "uitk-react-text";
var __fragment10 = gql11(_templateObject10(), ClientSideAnalyticsFragment);
var EGDSStandardLink = function(param) {
    var data = param.data, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? true : _param_showIcon;
    var action = data.action, text = data.text;
    var resource = action.resource, accessibility = action.accessibility, target = action.target, analytics = action.analytics;
    var clickTracker = useClickTracker6();
    var trackEvent = React10.useCallback(function() {
        sendTracking(analytics, clickTracker);
    }, [
        analytics,
        clickTracker
    ]);
    var linkTarget = target === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self";
    return /* @__PURE__ */ React10.createElement(UitkLink2, {
        onClickCapture: trackEvent
    }, /* @__PURE__ */ React10.createElement("a", {
        target: linkTarget,
        rel: "noopener",
        href: resource.value,
        "aria-label": accessibility || ""
    }, text, showIcon && /* @__PURE__ */ React10.createElement(UitkIcon3, {
        "data-stid": "lodging-link-message-icon",
        name: "arrow_forward",
        size: UitkIconSize4.EXTRA_SMALL
    }), accessibility && /* @__PURE__ */ React10.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = __fragment10;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/discovery-heading/fragments/discovery-heading-fragment.ts
import { gql as gql12 } from "@apollo/client";
var DiscoveryHeadingFragment = gql12(_templateObject11(), DiscoveryDisclaimerOverlay.fragment, EGDSStandardLink.fragment);
// ../internal/src/components/discovery-heading/discovery-heading.tsx
var DiscoveryHeading = function(props) {
    var data = props.data, highlightProps = props.highlightProps, titleProps = props.titleProps, subTitleProps = props.subTitleProps, _props_ariaHidden = props.ariaHidden, ariaHidden = _props_ariaHidden === void 0 ? false : _props_ariaHidden, _props_forceAriaHidden = props.forceAriaHidden, forceAriaHidden = _props_forceAriaHidden === void 0 ? false : _props_forceAriaHidden, legalContent = props.legalContent, pills = props.pills, title = props.title;
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, ariaHidden && /* @__PURE__ */ React11.createElement("div", {
        className: "is-visually-hidden"
    }, data.highlightAccessibilityLabel && /* @__PURE__ */ React11.createElement(UitkText3, null, data.highlightAccessibilityLabel), data.titleAccessibilityLabel && /* @__PURE__ */ React11.createElement(UitkText3, null, data.titleAccessibilityLabel), data.subTitleAccessibilityLabel && /* @__PURE__ */ React11.createElement(UitkText3, null, data.subTitleAccessibilityLabel)), data.highlight && /* @__PURE__ */ React11.createElement(UitkText3, _object_spread_props(_object_spread({}, highlightProps), {
        "aria-hidden": ariaHidden
    }), data.highlight), /* @__PURE__ */ React11.createElement(UitkSpacing2, {
        margin: {
            blockstart: data.highlight ? "two" : "unset"
        }
    }, /* @__PURE__ */ React11.createElement(UitkHeading, _object_spread_props(_object_spread({}, titleProps), {
        "aria-hidden": ariaHidden || forceAriaHidden
    }), title || data.title)), props.children, data.link && /* @__PURE__ */ React11.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React11.createElement(EGDSStandardLink, {
        data: data.link,
        showIcon: false
    })), data.subTitle && /* @__PURE__ */ React11.createElement(UitkText3, _object_spread_props(_object_spread({}, subTitleProps), {
        "aria-hidden": ariaHidden
    }), data.subTitle), pills, data.disclaimer && /* @__PURE__ */ React11.createElement(DiscoveryDisclaimerOverlay, {
        data: data.disclaimer
    }, legalContent));
};
DiscoveryHeading.fragment = DiscoveryHeadingFragment;
DiscoveryHeading.displayName = "DiscoveryHeading";
// ../internal/src/components/egds-badge/egds-badge.tsx
import React14 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkBadge, UitkBadgeLoyalty, UitkBadgeProgram, UitkBadgeSize, UitkBadgeStandard } from "uitk-react-badge";
// ../internal/src/components/egds-badge/__private/uitk-badge-theme-mapper.tsx
import { EGDSBadgeLoyaltyThemes, EGDSBadgeTheme } from "@egds/react-core/badge";
import { UitkBadgeProgramThemes, UitkBadgeStandardThemes, UitkBadgeTheme } from "uitk-react-badge";
var LOYALTY_MUTED_MID_TIER_KEY = "middletier";
var LOYALTY_MUTED_MID_TIER_VALUE = "midtier";
var LOYALTY_MUTED_HIGH_TIER = "hightier";
var LOYALTY_MUTED_EXTRA_HIGH_TIER = "extrahightier";
var LOYALTY_GLOBAL_LOW_TIER = "loyalty-global-low-tier";
var GLOBAL_LOW_TIER = "global-lowtier";
var LOYALTY_GLOBAL_MIDDLE_TIER = "loyalty-global-middle-tier";
var LOYALTY_GLOBAL_HIGH_TIER = "loyalty-global-high-tier";
var LOYALTY_GLOBAL_EXTRA_HIGH_TIER = "loyalty-global-extra-high-tier";
var _obj4;
var UitkBadgeThemeMapper = (_obj4 = {}, _define_property(_obj4, UitkBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _define_property(_obj4, UitkBadgeTheme.DEAL_GENERIC, "deal-generic"), _define_property(_obj4, UitkBadgeTheme.DEAL_MEMBER, "deal-member"), _define_property(_obj4, UitkBadgeTheme.NOTIFICATION_1, "notification-1"), _define_property(_obj4, UitkBadgeTheme.NOTIFICATION_2, "notification-2"), _define_property(_obj4, UitkBadgeTheme.VIP, "vip"), _define_property(_obj4, UitkBadgeTheme.LOYALTY_EXTRA_HIGH_TIER, "loyalty-extra-high-tier"), _define_property(_obj4, UitkBadgeTheme.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _define_property(_obj4, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _define_property(_obj4, UitkBadgeTheme.LOYALTY_LOW_TIER, "loyalty-low-tier"), _define_property(_obj4, UitkBadgeTheme.SPONSORED, "sponsored"), _define_property(_obj4, UitkBadgeTheme.VIEWED, "viewed"), _define_property(_obj4, UitkBadgeTheme.SAVED, "saved"), _define_property(_obj4, UitkBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _define_property(_obj4, UitkBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _define_property(_obj4, UitkBadgeTheme.PROMOTED, "promoted"), _obj4);
var UitkStandardBadgeThemeMapper = {
    standard: UitkBadgeStandardThemes.STANDARD,
    emphasis: UitkBadgeStandardThemes.EMPHASIS,
    info: UitkBadgeStandardThemes.INFO,
    featured: UitkBadgeStandardThemes.FEATURED,
    brand: UitkBadgeStandardThemes.BRAND,
    warning: UitkBadgeStandardThemes.WARNING,
    positive: UitkBadgeStandardThemes.POSITIVE
};
var _obj5;
var UitkLoyaltyBadgeThemeMapper = (_obj5 = {}, _define_property(_obj5, EGDSBadgeTheme.LOYALTY_EXTRA_HIGH_TIER, EGDSBadgeLoyaltyThemes.EXTRAHIGH), _define_property(_obj5, EGDSBadgeTheme.LOYALTY_HIGH_TIER, EGDSBadgeLoyaltyThemes.HIGH), _define_property(_obj5, EGDSBadgeTheme.LOYALTY_MIDDLE_TIER, EGDSBadgeLoyaltyThemes.MID), _define_property(_obj5, EGDSBadgeTheme.LOYALTY_LOW_TIER, EGDSBadgeLoyaltyThemes.LOW), _define_property(_obj5, LOYALTY_MUTED_MID_TIER_KEY, LOYALTY_MUTED_MID_TIER_VALUE), _define_property(_obj5, LOYALTY_MUTED_HIGH_TIER, LOYALTY_MUTED_HIGH_TIER), _define_property(_obj5, LOYALTY_MUTED_EXTRA_HIGH_TIER, LOYALTY_MUTED_EXTRA_HIGH_TIER), _define_property(_obj5, LOYALTY_GLOBAL_LOW_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_LOW), _define_property(_obj5, LOYALTY_GLOBAL_MIDDLE_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE), _define_property(_obj5, LOYALTY_GLOBAL_HIGH_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_HIGH), _define_property(_obj5, LOYALTY_GLOBAL_EXTRA_HIGH_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH), _define_property(_obj5, GLOBAL_LOW_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_LOW), _obj5);
var EGDSBadgeLoyaltyThemePerksMessageMapper = {
    LOYALTY_EXTRA_HIGH_TIER: EGDSBadgeLoyaltyThemes.EXTRAHIGH,
    LOYALTY_HIGH_TIER: EGDSBadgeLoyaltyThemes.HIGH,
    LOYALTY_MIDDLE_TIER: EGDSBadgeLoyaltyThemes.MID,
    LOYALTY_LOW_TIER: EGDSBadgeLoyaltyThemes.LOW,
    VIP: EGDSBadgeLoyaltyThemes.VIP,
    LOYALTY_GLOBAL_LOW_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_LOW,
    LOYALTY_GLOBAL_MIDDLE_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE,
    LOYALTY_GLOBAL_HIGH_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_HIGH,
    LOYALTY_GLOBAL_EXTRA_HIGH_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH
};
var UitkProgramBadgeThemeMapper = {
    deal: UitkBadgeProgramThemes.DEAL,
    member: UitkBadgeProgramThemes.MEMBER,
    trip: UitkBadgeProgramThemes.TRIP_SAVINGS,
    supplierpromo: UitkBadgeProgramThemes.SUPPLIER_PROMO,
    vmc: UitkBadgeProgramThemes.VIRTUAL_MARKET_COACH
};
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React13 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-mark/egds-mark.tsx
import React12 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql13(_templateObject12());
var EGDSMark = function(param) {
    var className = param.className, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React12.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __fragment11 = gql14(_templateObject13(), EGDSIcon.fragment, EGDSMark.fragment);
var EGDSGraphic = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React13.createElement(EGDSIcon, {
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React13.createElement(EGDSMark, {
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.fragment = __fragment11;
EGDSGraphic.displayName = "EGDSGraphic";
// ../internal/src/components/egds-badge/egds-badge.tsx
var __fragment12 = gql15(_templateObject14(), EGDSGraphic.fragment);
var EGDSBadge = function(param) {
    var className = param.className, data = param.data;
    var graphic = data.graphic, text = data.text, theme = data.theme, size = data.size, accessibility = data.accessibility;
    var badgeProps = React14.useMemo(function() {
        return {
            className: className !== null && className !== void 0 ? className : void 0,
            text: text !== null && text !== void 0 ? text : "",
            size: size ? UitkBadgeSize[size] : void 0,
            a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0
        };
    }, [
        text,
        theme,
        size
    ]);
    if (theme && UitkLoyaltyBadgeThemeMapper[theme]) {
        return /* @__PURE__ */ React14.createElement(UitkBadgeLoyalty, _object_spread({
            theme: UitkLoyaltyBadgeThemeMapper[theme]
        }, badgeProps), graphic && /* @__PURE__ */ React14.createElement(EGDSGraphic, {
            data: graphic
        }));
    }
    if (theme && UitkStandardBadgeThemeMapper[theme]) {
        return /* @__PURE__ */ React14.createElement(UitkBadgeStandard, _object_spread({
            theme: UitkStandardBadgeThemeMapper[theme]
        }, badgeProps), graphic && /* @__PURE__ */ React14.createElement(EGDSGraphic, {
            data: graphic
        }));
    }
    if (theme && UitkProgramBadgeThemeMapper[theme]) {
        var _UitkProgramBadgeThemeMapper_theme;
        return /* @__PURE__ */ React14.createElement(UitkBadgeProgram, _object_spread({
            theme: (_UitkProgramBadgeThemeMapper_theme = UitkProgramBadgeThemeMapper[theme]) !== null && _UitkProgramBadgeThemeMapper_theme !== void 0 ? _UitkProgramBadgeThemeMapper_theme : UitkBadgeThemeMapper[theme]
        }, badgeProps), graphic && /* @__PURE__ */ React14.createElement(EGDSGraphic, {
            data: graphic
        }));
    }
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ React14.createElement(UitkBadge, _object_spread({
        theme: theme ? UitkBadgeThemeMapper[theme] : void 0
    }, badgeProps), graphic && /* @__PURE__ */ React14.createElement(EGDSGraphic, {
        data: graphic
    })));
};
EGDSBadge.fragment = __fragment12;
EGDSBadge.displayName = "EGDSBadge";
// ../internal/src/components/egds-badge/egds-badges-heading.tsx
import React15 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
var __fragment13 = gql16(_templateObject15(), EGDSBadge.fragment);
var EGDSBadgesHeading = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? null : _param_size;
    var heading = data.heading;
    if (!heading.length) {
        return null;
    }
    return /* @__PURE__ */ React15.createElement(UitkLayoutFlex, {
        direction: "column",
        space: "one",
        alignItems: "start"
    }, heading.map(function(badge, index) /* @__PURE__ */ {
        var _badge_size;
        return React15.createElement(EGDSBadge, {
            data: _object_spread_props(_object_spread({}, badge), {
                size: (_badge_size = badge === null || badge === void 0 ? void 0 : badge.size) !== null && _badge_size !== void 0 ? _badge_size : size
            }),
            key: index
        });
    }));
};
EGDSBadgesHeading.fragment = __fragment13;
EGDSBadgesHeading.displayName = "EGDSBadgesHeading";
// ../internal/src/components/egds-badge/egds-badges-price.tsx
import React16 from "react";
import { gql as gql17 } from "@apollo/client";
var __fragment14 = gql17(_templateObject16(), EGDSBadge.fragment, ClientSideAnalyticsFragment);
var EGDSBadgesPrice = function(param) {
    var data = param.data;
    var price = data.price;
    if (!price) {
        return null;
    }
    return /* @__PURE__ */ React16.createElement(EGDSBadge, {
        data: price
    });
};
EGDSBadgesPrice.fragment = __fragment14;
EGDSBadgesPrice.displayName = "EGDSBadgesPrice";
// ../internal/src/components/egds-badge/egds-badges-pricebadge.tsx
import React17 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSButtonSize, EGDSPrimaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
var __fragment15 = gql18(_templateObject17(), EGDSBadge.fragment, ClientSideAnalyticsFragment);
var EGDSBadgesPriceBadge = function(param) {
    var data = param.data;
    var priceBadge = data.priceBadge;
    var graphic = priceBadge === null || priceBadge === void 0 ? void 0 : priceBadge.badge.graphic;
    var text = priceBadge === null || priceBadge === void 0 ? void 0 : priceBadge.badge.text;
    var action = priceBadge === null || priceBadge === void 0 ? void 0 : priceBadge.action;
    var analytics = action === null || action === void 0 ? void 0 : action.analytics;
    var trackClick = useClickTracker7();
    if (!priceBadge) {
        return null;
    }
    var handleOnClick = function() {
        if (analytics) {
            trackClick(analytics.referrerId, analytics.linkName);
        }
    };
    if (priceBadge === null || priceBadge === void 0 ? void 0 : priceBadge.action) {
        var _action_resource;
        return /* @__PURE__ */ React17.createElement(EGDSPrimaryButton, {
            type: "button",
            onClick: (action === null || action === void 0 ? void 0 : action.analytics) ? handleOnClick : void 0,
            tag: "a",
            href: action === null || action === void 0 ? void 0 : (_action_resource = action.resource) === null || _action_resource === void 0 ? void 0 : _action_resource.value,
            size: EGDSButtonSize.SMALL
        }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */ React17.createElement(UitkIcon4, {
            name: graphic.id
        }), text);
    }
    return /* @__PURE__ */ React17.createElement(EGDSBadge, {
        data: priceBadge.badge
    });
};
EGDSBadgesPriceBadge.fragment = __fragment15;
EGDSBadgesPriceBadge.displayName = "EGDSBadgesPriceBadge";
// ../internal/src/components/egds-badge/egds-badges-price-alt-button.tsx
import React18 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkText as UitkText4 } from "uitk-react-text";
var _obj6;
// ../internal/src/components/utils/ui-link-target-mapper.ts
var linkTargetMap = (_obj6 = {}, _define_property(_obj6, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj6, "INTERNAL" /* INTERNAL */ , "_self"), _obj6);
// ../internal/src/components/utils/ui-link-action.ts
var getUILinkActionPath = function(action, overrideUseRelativePath) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath || overrideUseRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = function(action) {
    return linkTargetMap[action.target];
};
var deriveLinkProps = function(action, overrideUseRelativePath) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getUILinkActionPath(action, overrideUseRelativePath);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getUILinkActionTarget(action),
        tag: "a"
    };
};
// ../internal/src/hooks/use-gss-redirect-url.tsx
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useBexApi } from "@shared-ui/bex-api-context";
var HOTWIRE = 30031;
var useGssRedirectUrl = function(baseUrl) {
    var getReturnUrlParam = function getReturnUrlParam(location2, siteId2) {
        var pathname = location2.pathname, search = location2.search, hash = location2.hash;
        var returnUrl = pathname.concat(search, hash);
        switch(siteId2){
            case HOTWIRE:
                return "&redirectUrl=targeturl=".concat(encodeURIComponent(returnUrl), "&referrerId=wl_prod");
            default:
                return "&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
        }
    };
    var hasRedirectUrl = baseUrl.indexOf("uurl") > -1;
    var currentLocation = useLocation();
    var getCurrentLocation = function() {
        return {
            pathname: "".concat(currentLocation.pathname),
            search: "".concat(currentLocation.search),
            hash: "".concat(currentLocation.hash)
        };
    };
    var context = useBexApi().context;
    var _useState = _sliced_to_array(useState(getCurrentLocation), 2), location = _useState[0], setLocation = _useState[1];
    var siteId = context === null || context === void 0 ? void 0 : context.siteId;
    useEffect(function() {
        var handleLocationChange = function() {
            return setLocation(getCurrentLocation());
        };
        window.addEventListener("popstate", handleLocationChange);
        return function() {
            return window.removeEventListener("popstate", handleLocationChange);
        };
    }, [
        getCurrentLocation
    ]);
    var authURL = "";
    if (!hasRedirectUrl) {
        authURL = baseUrl + (baseUrl.indexOf("?") !== -1 ? "" : "?") + getReturnUrlParam(location || {}, siteId);
    }
    return authURL;
};
// ../internal/src/components/egds-badge/egds-badges-price-alt-button.tsx
var __fragment16 = gql19(_templateObject18(), EGDSIcon.fragment, ClientSideAnalyticsFragment);
var EGDSBadgesPriceAltButton = function(param) {
    var data = param.data, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 200 : _param_textSize, iconSizeOverride = param.iconSizeOverride;
    var button = ((data === null || data === void 0 ? void 0 : data.priceButton) || {}).button;
    var trackClick = useClickTracker8();
    var linkProps = deriveLinkProps(button === null || button === void 0 ? void 0 : button.action);
    var _linkProps_href;
    var urlWithRedirect = useGssRedirectUrl((_linkProps_href = linkProps.href) !== null && _linkProps_href !== void 0 ? _linkProps_href : "");
    if (!button) {
        return null;
    }
    var primary = button.primary, icon = button.icon, action = button.action;
    if (!action || action.__typename !== "UILinkAction") {
        return null;
    }
    var _ref = action || {}, analytics = _ref.analytics, accessibility = _ref.accessibility;
    var handleOnClick = function() {
        if (analytics) {
            trackClick(analytics.referrerId, analytics.linkName);
        }
    };
    return /* @__PURE__ */ React18.createElement(EGDSPrimaryButton2, {
        type: "button",
        onClick: handleOnClick,
        tag: "a",
        href: urlWithRedirect,
        size: EGDSButtonSize2.SMALL,
        target: action === null || action === void 0 ? void 0 : action.target
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex2, {
        alignContent: "space-between",
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        space: "one"
    }, icon && /* @__PURE__ */ React18.createElement(EGDSIcon, {
        data: icon,
        iconSizeOverride: iconSizeOverride
    }), /* @__PURE__ */ React18.createElement(UitkText4, {
        size: textSize,
        theme: "inverse",
        "aria-hidden": true
    }, primary), /* @__PURE__ */ React18.createElement("div", {
        className: "is-visually-hidden"
    }, accessibility !== null && accessibility !== void 0 ? accessibility : primary)));
};
EGDSBadgesPriceAltButton.fragment = __fragment16;
EGDSBadgesPriceAltButton.displayName = "EGDSBadgesPriceAltButton";
// ../internal/src/components/egds-details-list/egds-details-list.tsx
import React30 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React19 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var __fragment17 = gql20(_templateObject19());
var EGDSPlainText = function(param) {
    var className = param.className, data = param.data, textSize = param.textSize, textWeight = param.textWeight, theme = param.theme, align = param.align;
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(UitkText5, {
        className: "is-visually-hidden"
    }, data.accessibility || data.text), /* @__PURE__ */ React19.createElement(UitkText5, {
        className: className,
        theme: theme || "default",
        size: textSize,
        weight: textWeight,
        "aria-hidden": true,
        align: align
    }, data.text));
};
EGDSPlainText.fragment = __fragment17;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-details-list/egds-bulleted-list.tsx
import React20 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkText as UitkText6 } from "uitk-react-text";
var __fragment18 = gql21(_templateObject20());
var EGDSBulletedList = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React20.createElement(UitkList, {
        bullet: "default"
    }, /* @__PURE__ */ React20.createElement("div", null, data.listItems.map(function(item, index) {
        return item.__typename === "EGDSTextStandardListItem" && /* @__PURE__ */ React20.createElement(UitkListItem, {
            key: index
        }, /* @__PURE__ */ React20.createElement(UitkText6, null, item.text));
    })));
};
EGDSBulletedList.fragment = __fragment18;
EGDSBulletedList.displayName = "EGDSBulletedList";
// ../internal/src/components/egds-details-list/egds-text-icon-list.tsx
import React23 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "uitk-react-layout-flex";
// ../internal/src/components/egds-details-list/egds-text-icon-list-item.tsx
import React22 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkText as UitkText8 } from "uitk-react-text";
// ../internal/src/components/egds-details-list/egds-nested-level-one-icon-list-item.tsx
import React21 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkText as UitkText7 } from "uitk-react-text";
var __fragment19 = gql22(_templateObject21());
var EGDSNestedLevelOneList = function(param) {
    var data = param.data, hideText = param.hideText;
    return /* @__PURE__ */ React21.createElement(UitkLayoutFlex3, {
        space: "two",
        wrap: "wrap"
    }, data.items.map(function(listItem, index) {
        var _listItem_icon;
        return /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem, {
            key: index
        }, /* @__PURE__ */ React21.createElement(UitkLayoutFlex3, {
            space: "two"
        }, listItem.__typename === "EGDSNestedLevelOneIconListItem" && ((_listItem_icon = listItem.icon) === null || _listItem_icon === void 0 ? void 0 : _listItem_icon.id) && /* @__PURE__ */ React21.createElement(UitkIcon5, {
            theme: "default",
            name: listItem.icon.id,
            size: UitkIconSize5.EXTRA_SMALL
        }), !hideText && listItem.__typename === "EGDSNestedLevelOneIconListItem" ? /* @__PURE__ */ React21.createElement(UitkText7, {
            theme: "standard",
            size: 200,
            overflow: "truncate-2-lines"
        }, listItem.text) : ""));
    }));
};
EGDSNestedLevelOneList.fragment = __fragment19;
EGDSNestedLevelOneList.displayName = "EGDSNestedLevelOneList";
// ../internal/src/components/egds-details-list/egds-text-icon-list-item.tsx
var __fragment20 = gql23(_templateObject22(), EGDSNestedLevelOneList.fragment);
var EGDSTextIconListItem = function(param) {
    var data = param.data, _param_hasNestedList = param.hasNestedList, hasNestedList = _param_hasNestedList === void 0 ? false : _param_hasNestedList, _param_hasMinWidth = param.hasMinWidth, hasMinWidth = _param_hasMinWidth === void 0 ? true : _param_hasMinWidth, iconGap = param.iconGap;
    var _data_icon;
    var minWidth = hasMinWidth ? _object_spread({}, hasNestedList ? {
        minWidth: "24x"
    } : {
        minWidth: "37x"
    }) : {};
    return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, _object_spread({
        alignSelf: "start"
    }, minWidth), /* @__PURE__ */ React22.createElement(UitkLayoutFlex4, {
        space: iconGap || "two"
    }, data.__typename === "EGDSTextIconListItem" && ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.id) && /* @__PURE__ */ React22.createElement(UitkIcon6, {
        theme: "default",
        name: data.icon.id,
        size: UitkIconSize6.EXTRA_SMALL
    }), /* @__PURE__ */ React22.createElement(UitkText8, {
        theme: "standard",
        size: 200,
        overflow: "truncate-2-lines"
    }, data.text))), data.nestedLevelOneList && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement(EGDSNestedLevelOneList, {
        data: data.nestedLevelOneList,
        hideText: true
    })));
};
EGDSTextIconListItem.fragment = __fragment20;
EGDSTextIconListItem.displayName = "EGDSTextIconListItem";
// ../internal/src/components/egds-details-list/egds-text-icon-list.tsx
var __fragment21 = gql24(_templateObject23(), EGDSTextIconListItem.fragment);
var EGDSTextIconList = function(param) {
    var data = param.data, _param_hasMinWidth = param.hasMinWidth, hasMinWidth = _param_hasMinWidth === void 0 ? true : _param_hasMinWidth, _param_hasWrap = param.hasWrap, hasWrap = _param_hasWrap === void 0 ? true : _param_hasWrap, iconGap = param.iconGap;
    var hasNestedList = data.listItems.find(function(item) {
        return item.nestedLevelOneList;
    });
    return /* @__PURE__ */ React23.createElement(UitkLayoutFlex5, {
        space: hasMinWidth ? "two" : "four",
        wrap: hasWrap ? "wrap" : "nowrap"
    }, data.listItems.map(function(item, index) {
        return /* @__PURE__ */ React23.createElement(EGDSTextIconListItem, {
            data: item,
            hasNestedList: !!hasNestedList,
            key: index,
            hasMinWidth: hasMinWidth,
            iconGap: iconGap
        });
    }));
};
EGDSTextIconList.fragment = __fragment21;
EGDSTextIconList.displayName = "EGDSTextIconList";
// ../internal/src/components/egds-details-list/egds-unordered-list.tsx
import React24 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText9 } from "uitk-react-text";
var __fragment22 = gql25(_templateObject24(), EGDSTextIconListItem.fragment);
var EGDSUnorderedList = function(param) {
    var data = param.data;
    var hasNestedList = data.listItems.some(function(item) {
        return item.__typename === "EGDSTextIconListItem" && item.nestedLevelOneList;
    });
    return /* @__PURE__ */ React24.createElement(React24.Fragment, null, data.listItems.map(function(item, index) {
        return /* @__PURE__ */ React24.createElement(React24.Fragment, {
            key: index
        }, item.__typename === "EGDSTextStandardListItem" && /* @__PURE__ */ React24.createElement(UitkText9, null, item.text), /* @__PURE__ */ React24.createElement(UitkSpacing3, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React24.createElement(UitkLayoutFlex6, {
            space: "two",
            wrap: "wrap"
        }, item.__typename === "EGDSTextIconListItem" && /* @__PURE__ */ React24.createElement(EGDSTextIconListItem, {
            data: item,
            hideText: true,
            hasNestedList: hasNestedList
        }))));
    }));
};
EGDSUnorderedList.fragment = __fragment22;
EGDSUnorderedList.displayName = "EGDSUnorderedList";
// ../internal/src/components/egds-details-list/enriched-details-list.tsx
import React29 from "react";
import { gql as gql30 } from "@apollo/client";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React26 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React25 from "react";
import { gql as gql26 } from "@apollo/client";
var __UIGraphicFragment = gql26(_templateObject25(), EGDSIcon.fragment);
var UIGraphic = function(param) {
    var className = param.className, data = param.data, iconSizeOverride = param.iconSizeOverride;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React25.createElement(EGDSIcon, {
                className: className,
                data: data,
                iconSizeOverride: iconSizeOverride
            });
        default:
            return null;
    }
};
UIGraphic.displayName = "UiGraphic";
UIGraphic.fragment = __UIGraphicFragment;
// ../internal/src/components/egds-text/egds-graphic-text.tsx
var fragment = gql27(_templateObject26(), UIGraphic.fragment);
var textPadding = {
    inlinestart: "one"
};
var EGDSGraphicText = function(param) {
    var className = param.className, data = param.data, textSize = param.textSize, textWeight = param.textWeight;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React26.createElement(UitkLayoutFlex7, {
        alignItems: "center"
    }, /* @__PURE__ */ React26.createElement(UIGraphic, {
        data: graphic
    }), /* @__PURE__ */ React26.createElement(UitkSpacing4, {
        padding: textPadding
    }, /* @__PURE__ */ React26.createElement(UitkText10, {
        className: className,
        size: textSize,
        weight: textWeight
    }, text)));
};
EGDSGraphicText.fragment = fragment;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-text.tsx
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
var fragment2 = gql28(_templateObject27(), EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSText = function(param) {
    var data = param.data, textSize = param.textSize, textWeight = param.textWeight, className = param.className, theme = param.theme, align = param.align;
    switch(data.__typename){
        case "EGDSGraphicText":
            return /* @__PURE__ */ React27.createElement(EGDSGraphicText, {
                className: className,
                data: data,
                textSize: textSize,
                textWeight: textWeight
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React27.createElement(EGDSPlainText, {
                align: align,
                className: className,
                data: data,
                textSize: textSize,
                textWeight: textWeight,
                theme: theme
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment2;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React28 from "react";
import { gql as gql29 } from "@apollo/client";
import { UitkText as UitkText11 } from "@egds/react-core/text";
var _obj7;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj7 = {}, _define_property(_obj7, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj7, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj7, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj7, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj7, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj7, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj7, "INVERSE" /* INVERSE */ , "inverse"), _obj7);
var _obj8;
var UitkTextThemeMapper = (_obj8 = {}, _define_property(_obj8, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj8, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj8, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj8, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj8, "DEFAULT" /* DEFAULT */ , "default"), _obj8);
var _obj9;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj9 = {}, _define_property(_obj9, "BOLD" /* BOLD */ , "bold"), _define_property(_obj9, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj9, "REGULAR" /* REGULAR */ , "regular"), _obj9);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment3 = gql29(_templateObject28());
var EGDSStylizedText = function(param) {
    var className = param.className, inline = param.inline, align = param.align, size = param.size, data = param.data;
    var text = data.text, theme = data.theme, weight = data.weight, accessibility = data.accessibility;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(UitkText11, {
        className: className,
        align: align,
        inline: inline,
        size: size,
        theme: themeProps,
        weight: weightProps,
        "aria-hidden": accessibility !== null
    }, text), accessibility && /* @__PURE__ */ React28.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment3;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-details-list/enriched-details-list.tsx
var fragment4 = gql30(_templateObject29(), EGDSText.fragment, EGDSTextIconList.fragment);
var EnrichedDetailsList = function(param) {
    var data = param.data;
    var additionalDescription = data.additionalDescription, list = data.list;
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, additionalDescription && /* @__PURE__ */ React29.createElement(EGDSText, {
        data: additionalDescription
    }), list && /* @__PURE__ */ React29.createElement(UitkSpacing5, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(EGDSTextIconList, {
        data: list,
        hasWrap: false
    }))));
};
EnrichedDetailsList.fragment = fragment4;
EnrichedDetailsList.displayName = "EnrichedDetailsList";
// ../internal/src/components/egds-details-list/egds-details-list.tsx
var __fragment23 = gql31(_templateObject30(), EGDSTextIconList.fragment, EGDSUnorderedList.fragment, EGDSPlainText.fragment, EGDSBulletedList.fragment, EnrichedDetailsList.fragment);
var EGDSDetailsList = function(props) {
    var data = props.data, hasMinWidth = props.hasMinWidth, hasWrap = props.hasWrap, spacing = props.spacing, iconGap = props.iconGap;
    switch(data.__typename){
        case "EGDSTextIconList":
            return /* @__PURE__ */ React30.createElement(UitkSpacing6, {
                margin: spacing && data.listItems.length ? spacing : void 0
            }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EGDSTextIconList, {
                data: data,
                hasMinWidth: hasMinWidth,
                hasWrap: hasWrap,
                iconGap: iconGap
            })));
        case "EGDSUnorderedList":
            return /* @__PURE__ */ React30.createElement(UitkSpacing6, {
                margin: spacing && data.listItems.length ? spacing : void 0
            }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EGDSUnorderedList, {
                data: data
            })));
        case "EGDSPlainText":
            return /* @__PURE__ */ React30.createElement(UitkSpacing6, {
                margin: spacing !== null && spacing !== void 0 ? spacing : void 0
            }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EGDSPlainText, {
                data: data
            })));
        case "EGDSBulletedList":
            return /* @__PURE__ */ React30.createElement(UitkSpacing6, {
                margin: spacing && data.listItems.length ? spacing : void 0
            }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EGDSBulletedList, {
                data: data
            })));
        case "EnrichedDetailsList":
            return /* @__PURE__ */ React30.createElement(UitkSpacing6, {
                margin: spacing !== null && spacing !== void 0 ? spacing : void 0
            }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EnrichedDetailsList, {
                data: data,
                hasWrap: hasWrap
            })));
        default:
            return null;
    }
};
EGDSDetailsList.fragment = __fragment23;
EGDSDetailsList.displayName = "EGDSDetailsList";
// ../internal/src/components/egds-rating/egds-rating.tsx
import React33 from "react";
import { gql as gql32 } from "@apollo/client";
// ../internal/src/components/egds-rating/__private/standard-rating.tsx
import React31 from "react";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
var StandardRating = function(param) {
    var data = param.data, primaryTextProps = param.primaryTextProps, secondaryTextProps = param.secondaryTextProps, supportingMessagesProps = param.supportingMessagesProps, showPrimaryTextPadding = param.showPrimaryTextPadding;
    var icon = data.icon, primary = data.primary, secondary = data.secondary, supportingMessages = data.supportingMessages, accessibilityLabel = data.accessibilityLabel;
    return /* @__PURE__ */ React31.createElement(EGDSLayoutFlex, {
        direction: "row",
        alignItems: "start"
    }, accessibilityLabel && /* @__PURE__ */ React31.createElement(UitkText12, {
        className: "is-visually-hidden"
    }, accessibilityLabel), icon && /* @__PURE__ */ React31.createElement(UitkSpacing7, {
        margin: {
            blockend: "half"
        }
    }, /* @__PURE__ */ React31.createElement("div", null, /* @__PURE__ */ React31.createElement(EGDSIcon, {
        data: icon
    }))), /* @__PURE__ */ React31.createElement(EGDSLayoutFlex, {
        direction: "row",
        alignItems: "center",
        wrap: "wrap",
        "aria-hidden": !!accessibilityLabel
    }, /* @__PURE__ */ React31.createElement(UitkSpacing7, {
        margin: {
            inlinestart: showPrimaryTextPadding ? "one" : "unset",
            inlineend: "one"
        }
    }, primary && /* @__PURE__ */ React31.createElement(UitkText12, _object_spread({}, primaryTextProps), primary)), secondary && /* @__PURE__ */ React31.createElement(UitkSpacing7, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React31.createElement(UitkText12, _object_spread({}, secondaryTextProps), secondary)), supportingMessages.map(function(item, index) {
        return item.__typename === "EGDSPlainText" && /* @__PURE__ */ React31.createElement(UitkText12, _object_spread_props(_object_spread({}, supportingMessagesProps), {
            key: index
        }), item.text);
    })));
};
// ../internal/src/components/egds-rating/__private/themed-badge-rating.tsx
import React32 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkText as UitkText13 } from "uitk-react-text";
// ../internal/src/components/utils/standard-badge-mapper.ts
var standardBadgeMapper = {
    STANDARD: "standard",
    EMPHASIS: "emphasis",
    INFO: "info",
    FEATURED: "featured",
    BRAND: "brand",
    WARNING: "warning",
    POSITIVE: "positive"
};
// ../internal/src/components/egds-rating/__private/themed-badge-rating.tsx
var ThemedBadgeRating = function(param) {
    var data = param.data, secondaryTextProps = param.secondaryTextProps, supportingMessagesProps = param.supportingMessagesProps;
    var theme = data.theme, accessibilityLabel = data.accessibilityLabel, primary = data.primary, secondary = data.secondary, supportingMessages = data.supportingMessages;
    var badgeTheme = theme ? standardBadgeMapper[theme === null || theme === void 0 ? void 0 : theme.toUpperCase()] : standardBadgeMapper.STANDARD;
    var secondaryWeight = theme ? "medium" : secondaryTextProps === null || secondaryTextProps === void 0 ? void 0 : secondaryTextProps.weight;
    return /* @__PURE__ */ React32.createElement("div", null, accessibilityLabel && /* @__PURE__ */ React32.createElement(UitkText13, {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React32.createElement(EGDSLayoutFlex2, {
        alignItems: "center",
        space: "one",
        "aria-hidden": !!accessibilityLabel
    }, primary && /* @__PURE__ */ React32.createElement(EGDSLayoutFlex2, null, /* @__PURE__ */ React32.createElement(EGDSBadgeStandard, {
        text: primary,
        theme: badgeTheme
    })), /* @__PURE__ */ React32.createElement(EGDSLayoutFlex2, {
        direction: "column"
    }, secondary && /* @__PURE__ */ React32.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React32.createElement(UitkText13, _object_spread_props(_object_spread({}, secondaryTextProps), {
        weight: secondaryWeight
    }), secondary)), supportingMessages.length > 0 && /* @__PURE__ */ React32.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React32.createElement("div", null, supportingMessages.map(function(item, index) {
        return item.__typename === "EGDSPlainText" && /* @__PURE__ */ React32.createElement(UitkText13, _object_spread_props(_object_spread({}, supportingMessagesProps), {
            key: index
        }), item.text);
    }))))));
};
// ../internal/src/components/egds-rating/egds-rating.tsx
var __fragment24 = gql32(_templateObject31(), EGDSIcon.fragment);
var EGDSRating = function(param) {
    var data = param.data, primaryTextProps = param.primaryTextProps, secondaryTextProps = param.secondaryTextProps, supportingMessagesProps = param.supportingMessagesProps, _param_showPrimaryTextPadding = param.showPrimaryTextPadding, showPrimaryTextPadding = _param_showPrimaryTextPadding === void 0 ? false : _param_showPrimaryTextPadding;
    var primary = data.primary, theme = data.theme;
    if (!primary) {
        return null;
    }
    if (theme) {
        return /* @__PURE__ */ React33.createElement(ThemedBadgeRating, {
            data: data,
            primaryTextProps: primaryTextProps,
            secondaryTextProps: secondaryTextProps,
            supportingMessagesProps: supportingMessagesProps,
            showPrimaryTextPadding: showPrimaryTextPadding
        });
    }
    return /* @__PURE__ */ React33.createElement(StandardRating, {
        data: data,
        primaryTextProps: primaryTextProps,
        secondaryTextProps: secondaryTextProps,
        supportingMessagesProps: supportingMessagesProps,
        showPrimaryTextPadding: showPrimaryTextPadding
    });
};
EGDSRating.fragment = __fragment24;
EGDSRating.displayName = "EGDSRating";
// ../internal/src/components/egds-ui-card-action/egds-ui-card-action.tsx
import React35 from "react";
import { gql as gql33 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkCardLink } from "uitk-react-cards";
// ../internal/src/components/utils/discovery-footer-provider.tsx
import React34 from "react";
var DiscoveryFooterContext = React34.createContext({
    isAttach: false
});
var useDiscoveryFooterContext = function() {
    return React34.useContext(DiscoveryFooterContext);
};
// ../internal/src/components/egds-ui-card-action/egds-ui-card-action.tsx
var __fragment25 = gql33(_templateObject32(), ClientSideAnalyticsFragment);
var EGDSUICardAction = function(param) {
    var data = param.data, seoEntityUrl = param.seoEntityUrl;
    var resource = data.resource, target = data.target, analytics = data.analytics, accessibility = data.accessibility;
    var isAttach = useDiscoveryFooterContext().isAttach;
    var cardActionhref = resource.value;
    var internalNavigationTarget = isAttach ? "_parent" : "_self";
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? internalNavigationTarget : "_blank";
    var clickTracker = useClickTracker9();
    var onClickCapture = React35.useCallback(function() {
        sendTracking(analytics, clickTracker);
    }, [
        analytics,
        clickTracker
    ]);
    var handleClick = function(e) {
        if (seoEntityUrl) {
            e.preventDefault();
            window.open(cardActionhref, navigationTarget, "noopener");
        }
    };
    return /* @__PURE__ */ React35.createElement(UitkCardLink, null, /* @__PURE__ */ React35.createElement("a", {
        href: seoEntityUrl || cardActionhref,
        target: navigationTarget,
        rel: "noopener",
        onClickCapture: onClickCapture,
        "aria-label": accessibility || "",
        onClick: handleClick
    }, accessibility));
};
EGDSUICardAction.fragment = __fragment25;
EGDSUICardAction.displayName = "EGDSUICardAction";
// ../internal/src/components/legacy-price/legacy-price.tsx
import React36 from "react";
import { gql as gql35 } from "@apollo/client";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
// ../internal/src/components/legacy-price/fragments/pricing-fragments.ts
import { gql as gql34 } from "@apollo/client";
var DiscoveryPriceSummaryFragment = gql34(_templateObject33());
// ../internal/src/components/legacy-price/legacy-price.tsx
var __fragment26 = gql35(_templateObject34(), DiscoveryPriceSummaryFragment);
var LegacyPrice = function(param) {
    var flexAlignment = param.flexAlignment, data = param.data, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    return /* @__PURE__ */ React36.createElement(PriceSummary, {
        data: data,
        flexAlignment: flexAlignment,
        enableInlineLink: enableInlineLink
    });
};
LegacyPrice.fragment = __fragment26;
LegacyPrice.displayName = "LegacyPrice";
// ../internal/src/components/trip-save-item/trip-save-item.tsx
import React37 from "react";
import { gql as gql37 } from "@apollo/client";
import { ReactPortalProvider } from "@shared-ui/portal-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/components/trip-save-item/fragment/trip-save-item-fragment.tsx
import { gql as gql36 } from "@apollo/client";
var __TripsSaveItemFragment = gql36(_templateObject35());
// ../internal/src/components/trip-save-item/trip-save-item.tsx
var __fragment27 = gql37(_templateObject36(), __TripsSaveItemFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var DiscoveryTripSaveItem = function(param) {
    var data = param.data, position = param.position, _param_source = param.source, source = _param_source === void 0 ? Source.LODGING_SEARCH : _param_source, _param_showRedOutline = param.showRedOutline, showRedOutline = _param_showRedOutline === void 0 ? false : _param_showRedOutline;
    var _React37_useState = _sliced_to_array(React37.useState({}), 2), reactPortalContext = _React37_useState[0], setReactPortalContext = _React37_useState[1];
    React37.useEffect(function() {
        setReactPortalContext({
            htmlElement: document.body
        });
    }, []);
    return /* @__PURE__ */ React37.createElement(ReactPortalProvider, {
        reactPortalContext: reactPortalContext
    }, /* @__PURE__ */ React37.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React37.createElement(TripSaveItem, {
        data: data,
        source: source,
        heartLayoutPosition: position,
        showRedOutline: showRedOutline
    })));
};
DiscoveryTripSaveItem.fragment = __fragment27;
DiscoveryTripSaveItem.displayName = "DiscoveryTripSaveItem";
// ../internal/src/components/cards/fragments/discovery-card-fragment.ts
import { gql as gql49 } from "@apollo/client";
// ../internal/src/components/ad-badge/ad-badge.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { TransparencyTriggerType as TransparencyTriggerType2 } from "@shared-ui/retail-sponsored-content-transparency";
// ../internal/src/components/ad-badge/ad-transparency-trigger.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
import { Transparency, TransparencyTriggerType } from "@shared-ui/retail-sponsored-content-transparency";
var fragment5 = gql38(_templateObject37());
var AdTransparencyTrigger = function(param) {
    var data = param.data, _param_type = param.type, type = _param_type === void 0 ? TransparencyTriggerType.NATIVE_AD : _param_type, className = param.className;
    if (!(data === null || data === void 0 ? void 0 : data.adTransparencyButton)) {
        return null;
    }
    var transparencysProps = {
        type: type,
        className: className
    };
    return /* @__PURE__ */ React38.createElement(Transparency, _object_spread({
        data: data
    }, transparencysProps));
};
AdTransparencyTrigger.fragment = fragment5;
AdTransparencyTrigger.displayName = "AdTransparencyTrigger";
// ../internal/src/components/ad-badge/ad-badge.tsx
var fragment6 = gql39(_templateObject38(), EGDSBadge.fragment, AdTransparencyTrigger.fragment);
var AdBadge = function(param) {
    var data = param.data, _param_type = param.type, type = _param_type === void 0 ? TransparencyTriggerType2.NATIVE_AD : _param_type, className = param.className;
    var adBadge = data === null || data === void 0 ? void 0 : data.adBadge;
    var isAdTransparencyTrigger = (adBadge === null || adBadge === void 0 ? void 0 : adBadge.__typename) === "AdTransparencyTrigger";
    var transparencysProps = {
        type: type,
        className: className
    };
    return /* @__PURE__ */ React39.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: {
            left: "three",
            bottom: "three",
            zindex: isAdTransparencyTrigger ? "layer2" : "layer1"
        }
    }, isAdTransparencyTrigger ? /* @__PURE__ */ React39.createElement(AdTransparencyTrigger, _object_spread({
        data: adBadge
    }, transparencysProps)) : adBadge && /* @__PURE__ */ React39.createElement(EGDSBadge, {
        data: adBadge
    }));
};
AdBadge.fragment = fragment6;
AdBadge.displayName = "AdBadge";
// ../internal/src/components/discovery-card-location/discovery-card-location.tsx
import React40 from "react";
import { gql as gql40 } from "@apollo/client";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
var __fragment28 = gql40(_templateObject39());
var DiscoveryCardLocation = function(param) {
    var className = param.className, textSize = param.textSize, textWeight = param.textWeight, data = param.data;
    var leadingIcon = data.leadingIcon, text = data.text;
    switch(text.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React40.createElement(UitkLayoutFlex8, {
                space: "one",
                alignItems: "center"
            }, /* @__PURE__ */ React40.createElement(UitkIcon7, {
                name: leadingIcon.id
            }), /* @__PURE__ */ React40.createElement(EGDSPlainText, {
                data: text,
                textSize: textSize,
                className: className,
                textWeight: textWeight
            }));
        default:
            return null;
    }
};
DiscoveryCardLocation.fragment = __fragment28;
DiscoveryCardLocation.displayName = "DiscoveryCardLocation";
// ../internal/src/components/discovery-star-rating/discovery-star-rating.tsx
import React41 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var __fragment29 = gql41(_templateObject40());
var DiscoveryStarRating = function(param) {
    var data = param.data;
    var rating = data.rating, accessibility = data.accessibility, icon = data.icon;
    var iconId = icon.id === "alternate" ? "alternate" : "star";
    return /* @__PURE__ */ React41.createElement(UitkRating, {
        icon: iconId,
        rating: String(rating),
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0
    });
};
DiscoveryStarRating.fragment = __fragment29;
DiscoveryStarRating.displayName = "DiscoveryStarRating";
// ../internal/src/components/property-uniqueness/property-uniqueness.tsx
import React46 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkCard, UitkCardBackgroundThemes } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
// ../internal/src/components/egds-spannable-list/egds-spannable-list.tsx
import React45 from "react";
import { gql as gql45 } from "@apollo/client";
import { UitkList as UitkList2 } from "@egds/react-core/list";
// ../internal/src/components/egds-spannable-list/egds-spannable-list-item.tsx
import React44 from "react";
import { gql as gql44 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing8 } from "@egds/react-core/spacing";
import { UitkText as UitkText15 } from "@egds/react-core/text";
// ../internal/src/components/egds-spannable-text/egds-spannable-text.tsx
import React43 from "react";
import { gql as gql43 } from "@apollo/client";
import { UitkText as UitkText14 } from "@egds/react-core/text";
// ../internal/src/components/egds-spannable-text/egds-spannable-text-content.tsx
import React42 from "react";
import { gql as gql42 } from "@apollo/client";
var fragment7 = gql42(_templateObject41(), EGDSStylizedText.fragment, EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, align = param.align, theme = param.theme, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React42.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React42.createElement(EGDSGraphicText, {
                className: className,
                data: data
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React42.createElement(EGDSPlainText, {
                className: className,
                data: data,
                align: align,
                theme: theme
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment7;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-spannable-text/egds-spannable-text.tsx
var fragment8 = gql43(_templateObject42(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, headingSize = props.headingSize, data = props.data, theme = props.theme, styleProps = _object_without_properties(props, [
        "align",
        "headingSize",
        "data",
        "theme"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React43.createElement(UitkText14, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align,
            theme: theme
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React43.createElement(React43.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
                align: align,
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index),
                theme: theme
            })), " ");
        }));
    }
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React43.createElement(React43.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React43.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
            data: item
        }, styleProps), {
            headingSize: headingSize,
            theme: theme
        })), " ");
    }));
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-spannable-list/egds-spannable-list-item.tsx
var fragment9 = gql44(_templateObject43(), UIGraphic.fragment, EGDSSpannableText.fragment);
var EGDSSpannableListItem = function(_param) {
    var data = _param.data, styleProps = _object_without_properties(_param, [
        "data"
    ]);
    var graphic = data.graphic, subText = data.subText, text = data.text;
    return /* @__PURE__ */ React44.createElement(UitkLayoutFlex9, null, /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, graphic && /* @__PURE__ */ React44.createElement(UitkSpacing8, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(UIGraphic, {
        data: graphic
    })))), /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSSpannableText, _object_spread({
        data: text
    }, styleProps)), /* @__PURE__ */ React44.createElement(UitkText15, null, subText))));
};
EGDSSpannableListItem.displayName = "EGDSSpannableListItem";
EGDSSpannableListItem.fragment = fragment9;
// ../internal/src/components/egds-spannable-list/egds-spannable-list.tsx
var fragment10 = gql45(_templateObject44(), EGDSSpannableListItem.fragment);
var bulletListTypeMapping = function(listType) {
    switch(listType){
        case "BULLET":
            return "default";
        case "ICON":
            return "icon-standard";
        case "NO_BULLET":
            return "no-bullet";
        case "NUMBER":
            return "tiered-numbered";
        default:
            return void 0;
    }
};
var EGDSSpannableList = function(_param) {
    var data = _param.data, stypeProps = _object_without_properties(_param, [
        "data"
    ]);
    if (data.items.length === 0) {
        return null;
    }
    var listType = data.listType, items = data.items;
    return /* @__PURE__ */ React45.createElement(UitkList2, {
        bullet: bulletListTypeMapping(listType),
        spacing: false
    }, items.map(function(item, key) {
        return /* @__PURE__ */ React45.createElement(EGDSSpannableListItem, _object_spread_props(_object_spread({
            data: item
        }, stypeProps), {
            key: key
        }));
    }));
};
EGDSSpannableList.displayName = "EGDSSpannableList";
EGDSSpannableList.fragment = fragment10;
// ../internal/src/components/property-uniqueness/property-uniqueness.tsx
var __fragment30 = gql46(_templateObject45(), EGDSSpannableList.fragment, EGDSGraphicText.fragment);
var PropertyUniqueness = function(_param) {
    var data = _param.data, _param_isFullWidth = _param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth, _param_cardPadding = _param.cardPadding, cardPadding = _param_cardPadding === void 0 ? "four" : _param_cardPadding, styleProps = _object_without_properties(_param, [
        "data",
        "isFullWidth",
        "cardPadding"
    ]);
    if (!data) {
        return null;
    }
    var background = data.background, details = data.details, title = data.title;
    if (!title && !details) {
        return null;
    }
    var cardBackground = background || UitkCardBackgroundThemes.PRIMARY;
    var card = /* @__PURE__ */ React46.createElement(UitkSpacing9, {
        padding: cardPadding
    }, /* @__PURE__ */ React46.createElement(UitkCard, {
        backgroundTheme: cardBackground
    }, /* @__PURE__ */ React46.createElement("div", null, title && /* @__PURE__ */ React46.createElement(EGDSGraphicText, {
        data: title
    }), details && /* @__PURE__ */ React46.createElement(EGDSSpannableList, _object_spread({
        data: details
    }, styleProps)))));
    return isFullWidth ? card : /* @__PURE__ */ React46.createElement(EGDSLayoutFlex3, null, /* @__PURE__ */ React46.createElement(EGDSLayoutFlexItem2, {
        maxWidth: "180x"
    }, card));
};
PropertyUniqueness.fragment = __fragment30;
PropertyUniqueness.displayName = "PropertyUniqueness";
// ../internal/src/components/review-snippet/review-snippet.tsx
import React48 from "react";
import { gql as gql48 } from "@apollo/client";
// ../internal/src/components/egds-expando-peek/egds-expando-peek.tsx
import React47 from "react";
import { gql as gql47 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
var fragment11 = gql47(_templateObject46());
var EGDSExpandoPeek = function(param) {
    var className = param.className, data = param.data, children = param.children;
    var expandAnalytics = data.expandAnalytics, collapseAnalytics = data.collapseAnalytics, expandedLabel = data.expandedLabel, collapsedLabel = data.collapsedLabel, lines = data.lines, expanded = data.expanded;
    var _React47_useState = _sliced_to_array(React47.useState(expanded), 2), isVisible = _React47_useState[0], setIsVisible = _React47_useState[1];
    var handleClickAction = React47.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var clickTracker = useClickTracker10();
    var expandoReferrerId = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId;
    var expandoLinkName = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName;
    var expandoAnalytics = {
        id: expandoReferrerId !== null && expandoReferrerId !== void 0 ? expandoReferrerId : "",
        description: expandoLinkName !== null && expandoLinkName !== void 0 ? expandoLinkName : "",
        callback: function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React47.createElement(UitkExpandoPeek, {
        lines: lines || 2,
        expandLabel: collapsedLabel,
        collapseLabel: expandedLabel,
        analytics: expandoAnalytics,
        className: className,
        isVisible: isVisible,
        handleClick: handleClickAction
    }, children);
};
EGDSExpandoPeek.fragment = fragment11;
EGDSExpandoPeek.displayName = "EGDSExpandoPeek";
// ../internal/src/components/review-snippet/review-snippet.tsx
var __fragment31 = gql48(_templateObject47(), EGDSExpandoPeek.fragment);
var ReviewSnippet = function(param) {
    var data = param.data;
    if (!data || !data.text) {
        return null;
    }
    var text = data.text, textControl = data.textControl;
    return /* @__PURE__ */ React48.createElement(EGDSExpandoPeek, {
        data: textControl
    }, /* @__PURE__ */ React48.createElement(React48.Fragment, null, text));
};
ReviewSnippet.fragment = __fragment31;
ReviewSnippet.displayName = "ReviewSnippet";
// ../internal/src/components/cards/fragments/discovery-card-fragment.ts
var DiscoveryCardFragment = gql49(_templateObject48(), ClientSideAnalyticsFragment, DiscoveryHeadingFragment, DiscoveryCardMedia.fragment, EGDSBadgesHeading.fragment, EGDSBadgesPrice.fragment, EGDSBadgesPriceAltButton.fragment, AdBadge.fragment, EGDSRating.fragment, EGDSDetailsList.fragment, LegacyPrice.fragment, EGDSUICardAction.fragment, DiscoveryTripSaveItem.fragment, DiscoveryStarRating.fragment, DiscoveryCardLocation.fragment, ReviewSnippet.fragment, EGDSIcon.fragment, PropertyUniqueness.fragment);
// ../internal/src/components/cards/foundation-card.tsx
var FoundationCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, detailsList = data.detailsList, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var _useInView2 = useInView2({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView2.ref, inView = _useInView2.inView;
    var cardComponent = /* @__PURE__ */ React49.createElement(UitkCard2, {
        border: true
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlex10, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React49.createElement("div", null, (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React49.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            zindex: "layer1",
            top: "three",
            left: "three"
        }
    }, /* @__PURE__ */ React49.createElement(EGDSBadgesHeading, {
        data: badges
    })), tripSaveItem && /* @__PURE__ */ React49.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer3"
            }
        }
    }), media && /* @__PURE__ */ React49.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React49.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            roundcorner: [
                "startstart",
                "startend"
            ],
            ratio: UitkFigureAspectRatioType3.R21_9
        },
        shouldLazyLoadImg: !inView
    })), /* @__PURE__ */ React49.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React49.createElement(UitkSpacing10, {
        padding: {
            inline: "three",
            blockstart: "three",
            blockend: showPrice ? "two" : "three"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, heading && /* @__PURE__ */ React49.createElement(DiscoveryHeading, {
        data: heading,
        titleProps: {
            tag: "h3",
            size: 6,
            overflow: "truncate-3-lines"
        },
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-3-lines"
        },
        highlightProps: {
            size: 200,
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }), detailsList && /* @__PURE__ */ React49.createElement(UitkSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(EGDSDetailsList, {
        data: detailsList
    }))), rating && /* @__PURE__ */ React49.createElement(UitkSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        secondaryTextProps: {
            size: 300
        },
        supportingMessagesProps: {
            size: 200
        }
    }))))))), showPrice && /* @__PURE__ */ React49.createElement(UitkCardContentSection, {
        padded: [
            "blockend",
            "inlineend"
        ]
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlex10, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, (badges === null || badges === void 0 ? void 0 : badges.price) && /* @__PURE__ */ React49.createElement(EGDSBadgesPrice, {
        data: badges
    }), /* @__PURE__ */ React49.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    }))), /* @__PURE__ */ React49.createElement(EGDSUICardAction, {
        data: cardAction
    })));
    return withoutIntersectionTracker ? /* @__PURE__ */ React49.createElement(React49.Fragment, null, cardComponent) : /* @__PURE__ */ React49.createElement(UitkLayoutFlex10, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem4, {
        grow: 1
    }, /* @__PURE__ */ React49.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent)));
};
FoundationCard.fragment = DiscoveryCardFragment;
FoundationCard.displayName = "FoundationCard";
// ../internal/src/components/cards/abbreviated-card.tsx
import React50 from "react";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var AbbreviatedCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker, outputLineOfBusiness = param.outputLineOfBusiness;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, detailsList = data.detailsList, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem, location = data.location;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var truncate = outputLineOfBusiness === "LODGING" ? "truncate-2-lines" : "truncate-3-lines";
    var cardComponent = /* @__PURE__ */ React50.createElement(UitkCard3, {
        border: true
    }, /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React50.createElement(UitkLayoutFlex11, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React50.createElement("div", null, tripSaveItem && /* @__PURE__ */ React50.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer3"
            }
        }
    }), media && /* @__PURE__ */ React50.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            ratio: UitkFigureAspectRatioType4.R16_9
        }
    }), /* @__PURE__ */ React50.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        margin: {
            blockstart: "two"
        },
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, heading && /* @__PURE__ */ React50.createElement(DiscoveryHeading, {
        data: heading,
        titleProps: {
            tag: "h4",
            size: 7,
            overflow: truncate
        },
        ariaHidden: true
    }), detailsList && /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(EGDSDetailsList, {
        data: detailsList,
        hasWrap: false,
        iconGap: "half"
    }))), rating && /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 300
        },
        secondaryTextProps: {
            size: 200
        },
        supportingMessagesProps: {
            size: 200
        }
    }))), location && /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(DiscoveryCardLocation, {
        data: location,
        textSize: 200,
        textWeight: "regular"
    }))))))), showPrice && /* @__PURE__ */ React50.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        margin: {
            blockstart: "two",
            blockend: "one"
        },
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React50.createElement(UitkLayoutFlex11, {
        space: "one",
        direction: "column",
        alignItems: "start"
    }, (badges === null || badges === void 0 ? void 0 : badges.price) && /* @__PURE__ */ React50.createElement(EGDSBadgesPrice, {
        data: badges
    }), /* @__PURE__ */ React50.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "start"
    })))), /* @__PURE__ */ React50.createElement(EGDSUICardAction, {
        data: cardAction
    }))));
    return withoutIntersectionTracker ? /* @__PURE__ */ React50.createElement(React50.Fragment, null, cardComponent) : /* @__PURE__ */ React50.createElement(UitkLayoutFlex11, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React50.createElement(UitkSpacing11, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React50.createElement(UitkLayoutFlexItem5, {
        grow: 1
    }, /* @__PURE__ */ React50.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent))));
};
AbbreviatedCard.fragment = DiscoveryCardFragment;
AbbreviatedCard.displayName = "AbbreviatedCard";
// ../internal/src/components/cards/uber-abbreviated-card.tsx
import React51 from "react";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView3 } from "react-intersection-observer";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
var UberAbbreviatedCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker, outputLineOfBusiness = param.outputLineOfBusiness, cardTitleTagProps = param.cardTitleTagProps, onHoverChanged = param.onHoverChanged;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, rating = data.rating, tripSaveItem = data.tripSaveItem;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var truncate = outputLineOfBusiness === "LODGING" ? "truncate-2-lines" : "truncate-3-lines";
    var onMouseOver = React51.useCallback(function() {
        onHoverChanged === null || onHoverChanged === void 0 ? void 0 : onHoverChanged(true, data);
    }, [
        onHoverChanged,
        data
    ]);
    var onMouseLeave = React51.useCallback(function() {
        onHoverChanged === null || onHoverChanged === void 0 ? void 0 : onHoverChanged(false, data);
    }, [
        onHoverChanged,
        data
    ]);
    var _useInView3 = useInView3({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView3.ref, inView = _useInView3.inView;
    var cardComponent = /* @__PURE__ */ React51.createElement(UitkCard4, {
        border: true,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    }, /* @__PURE__ */ React51.createElement(UitkLayoutFlex12, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React51.createElement(UitkSpacing12, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement("div", null, tripSaveItem && /* @__PURE__ */ React51.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer3"
            }
        }
    }), media && /* @__PURE__ */ React51.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React51.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            ratio: UitkFigureAspectRatioType5.R16_9
        },
        shouldLazyLoadImg: !inView
    })), /* @__PURE__ */ React51.createElement(UitkCardContentSection3, {
        padded: false
    }, /* @__PURE__ */ React51.createElement(UitkSpacing12, {
        margin: {
            blockstart: "two"
        },
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React51.createElement("div", null, heading && /* @__PURE__ */ React51.createElement(DiscoveryHeading, {
        data: heading,
        titleProps: {
            tag: cardTitleTagProps || "h4",
            size: 7,
            overflow: truncate
        },
        ariaHidden: true
    }), rating && /* @__PURE__ */ React51.createElement(UitkSpacing12, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 300
        },
        secondaryTextProps: {
            size: 200
        },
        supportingMessagesProps: {
            size: 200
        }
    }))))))), showPrice && /* @__PURE__ */ React51.createElement(UitkSpacing12, {
        margin: {
            blockstart: "two",
            blockend: "one"
        },
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React51.createElement(UitkLayoutFlex12, {
        space: "one",
        direction: "column",
        alignItems: "start"
    }, /* @__PURE__ */ React51.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "start",
        enableInlineLink: true
    }))), /* @__PURE__ */ React51.createElement(EGDSUICardAction, {
        data: cardAction
    })))));
    return withoutIntersectionTracker ? /* @__PURE__ */ React51.createElement(React51.Fragment, null, cardComponent) : /* @__PURE__ */ React51.createElement(UitkLayoutFlex12, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React51.createElement(UitkLayoutFlexItem6, {
        grow: 1
    }, /* @__PURE__ */ React51.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent)));
};
UberAbbreviatedCard.fragment = DiscoveryCardFragment;
UberAbbreviatedCard.displayName = "UberAbbreviatedCard";
// ../internal/src/components/cards/long-form-card.tsx
import React52 from "react";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView4 } from "react-intersection-observer";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
var LongFormCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, detailsList = data.detailsList, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var _useInView4 = useInView4({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView4.ref, inView = _useInView4.inView;
    var cardComponent = /* @__PURE__ */ React52.createElement(UitkCard5, {
        border: true,
        backgroundTheme: "primary"
    }, /* @__PURE__ */ React52.createElement(UitkLayoutFlex13, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React52.createElement("div", null, (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React52.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            zindex: "layer1",
            top: "three",
            left: "three"
        }
    }, /* @__PURE__ */ React52.createElement(EGDSBadgesHeading, {
        data: badges
    })), tripSaveItem && /* @__PURE__ */ React52.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer3"
            }
        }
    }), media && /* @__PURE__ */ React52.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React52.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            roundcorner: [
                "startstart",
                "startend"
            ]
        },
        shouldLazyLoadImg: !inView
    })), /* @__PURE__ */ React52.createElement(UitkCardContentSection4, {
        padded: true
    }, heading && /* @__PURE__ */ React52.createElement(DiscoveryHeading, {
        data: heading,
        titleProps: {
            tag: "h3",
            size: 6,
            overflow: "truncate-3-lines"
        },
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-3-lines"
        },
        highlightProps: {
            size: 200,
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }), detailsList && /* @__PURE__ */ React52.createElement(EGDSDetailsList, {
        data: detailsList,
        spacing: {
            blockstart: "two"
        }
    }), rating && /* @__PURE__ */ React52.createElement(UitkSpacing13, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        secondaryTextProps: {
            size: 300
        },
        supportingMessagesProps: {
            size: 200
        }
    }))))), showPrice && /* @__PURE__ */ React52.createElement(UitkCardContentSection4, {
        padded: [
            "blockend",
            "inlineend"
        ]
    }, /* @__PURE__ */ React52.createElement(UitkLayoutFlex13, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, (badges === null || badges === void 0 ? void 0 : badges.price) && /* @__PURE__ */ React52.createElement(EGDSBadgesPrice, {
        data: badges
    }), /* @__PURE__ */ React52.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    }))), /* @__PURE__ */ React52.createElement(EGDSUICardAction, {
        data: cardAction
    })));
    return withoutIntersectionTracker ? /* @__PURE__ */ React52.createElement(React52.Fragment, null, cardComponent) : /* @__PURE__ */ React52.createElement(UitkLayoutFlex13, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React52.createElement(UitkLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React52.createElement(IntersectionTracker4, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent)));
};
LongFormCard.fragment = DiscoveryCardFragment;
LongFormCard.displayName = "LongFormCard";
// ../internal/src/components/cards/list-card.tsx
import React55 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { useInView as useInView5 } from "react-intersection-observer";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
// ../internal/src/components/discovery-heading/discovery-heading-subtitle.tsx
import React53 from "react";
import { UitkText as UitkText16 } from "uitk-react-text";
var DiscoveryHeadingSubtitle = function(param) {
    var data = param.data, subTitleProps = param.subTitleProps, _param_ariaHidden = param.ariaHidden, ariaHidden = _param_ariaHidden === void 0 ? false : _param_ariaHidden;
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, ariaHidden && /* @__PURE__ */ React53.createElement("div", {
        className: "is-visually-hidden"
    }, data.subTitleAccessibilityLabel && /* @__PURE__ */ React53.createElement(UitkText16, null, data.subTitleAccessibilityLabel)), data.subTitle && /* @__PURE__ */ React53.createElement(UitkText16, _object_spread_props(_object_spread({}, subTitleProps), {
        "aria-hidden": ariaHidden
    }), data.subTitle));
};
DiscoveryHeadingSubtitle.fragment = DiscoveryHeadingFragment;
DiscoveryHeadingSubtitle.displayName = "DiscoveryHeadingSubtitle";
// ../internal/src/components/discovery-heading/discovery-heading-title.tsx
import React54 from "react";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText17 } from "uitk-react-text";
var DiscoveryHeadingTitle = function(param) {
    var data = param.data, highlightProps = param.highlightProps, titleProps = param.titleProps, _param_ariaHidden = param.ariaHidden, ariaHidden = _param_ariaHidden === void 0 ? false : _param_ariaHidden, enableTruncate = param.enableTruncate;
    return /* @__PURE__ */ React54.createElement(React54.Fragment, null, ariaHidden && /* @__PURE__ */ React54.createElement("div", {
        className: "is-visually-hidden"
    }, data.highlightAccessibilityLabel && /* @__PURE__ */ React54.createElement(UitkText17, null, data.highlightAccessibilityLabel), data.titleAccessibilityLabel && /* @__PURE__ */ React54.createElement(UitkText17, null, data.titleAccessibilityLabel)), data.highlight && /* @__PURE__ */ React54.createElement(UitkText17, _object_spread_props(_object_spread({}, highlightProps), {
        "aria-hidden": ariaHidden
    }), data.highlight), /* @__PURE__ */ React54.createElement(UitkSpacing14, {
        margin: {
            blockstart: data.highlight ? "two" : "unset"
        }
    }, /* @__PURE__ */ React54.createElement(UitkHeading2, _object_spread_props(_object_spread({}, titleProps), {
        "aria-hidden": ariaHidden,
        overflow: enableTruncate ? "truncate" : void 0
    }), data.title)));
};
DiscoveryHeadingTitle.fragment = DiscoveryHeadingFragment;
DiscoveryHeadingTitle.displayName = "DiscoveryHeadingTitle";
// ../internal/src/components/cards/list-card.tsx
var ListCard = function(param) {
    var data = param.data, _param_enableImgLoadingState = param.enableImgLoadingState, enableImgLoadingState = _param_enableImgLoadingState === void 0 ? false : _param_enableImgLoadingState, _param_border = param.border, border = _param_border === void 0 ? true : _param_border, priceExtraSpace = param.priceExtraSpace, titleProps = param.titleProps, cardTitleTagProps = param.cardTitleTagProps, handleMouseOver = param.handleMouseOver, handleMouseLeave = param.handleMouseLeave, _param_carouselLoop = param.carouselLoop, carouselLoop = _param_carouselLoop === void 0 ? false : _param_carouselLoop, _param_tripSaveItemPosition = param.tripSaveItemPosition, tripSaveItemPosition = _param_tripSaveItemPosition === void 0 ? {
        type: "absolute",
        position: {
            top: "one",
            right: "one",
            zindex: "layer2"
        }
    } : _param_tripSaveItemPosition, tripsPlanSource = param.tripsPlanSource, _param_view = param.view, view = _param_view === void 0 ? "LANDING" /* LANDING */  : _param_view;
    var _badges_priceBadge, _badges_priceBadge1, _badges_priceBadge2, _badges_priceButton_button, _badges_priceButton;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem, starRating = data.starRating, reviewSnippet = data.reviewSnippet, uniqueness = data.uniqueness, id = data.id, seoEntityUrl = data.seoEntityUrl, detailsList = data.detailsList;
    var viewport = useMediaQueries3({
        viewSizes: defaultViewSizes3
    });
    var isSmallViewport = viewport === defaultViewSizes3.SMALL;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var _useInView5 = useInView5({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView5.ref, inView = _useInView5.inView;
    var onMouseOver = React55.useCallback(function() {
        handleMouseOver === null || handleMouseOver === void 0 ? void 0 : handleMouseOver(id !== null && id !== void 0 ? id : "");
    }, [
        handleMouseOver,
        id
    ]);
    var onMouseLeave = React55.useCallback(function() {
        handleMouseLeave === null || handleMouseLeave === void 0 ? void 0 : handleMouseLeave(id !== null && id !== void 0 ? id : "");
    }, [
        handleMouseLeave,
        id
    ]);
    return /* @__PURE__ */ React55.createElement(IntersectionTracker5, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, /* @__PURE__ */ React55.createElement(UitkCard6, {
        border: border,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGrid, {
        columns: {
            small: view === "LANDING" /* LANDING */  ? 1 : 3,
            medium: 3
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutPosition4, {
        type: "relative"
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        blockSize: "full_size",
        domRef: ref
    }, media && /* @__PURE__ */ React55.createElement(DiscoveryCardMedia, {
        data: media,
        showAttribution: false,
        figureProps: {
            imageFit: "cover"
        },
        carouselLoop: carouselLoop,
        imageLink: cardAction,
        shouldLazyLoadImg: !inView,
        enableImgLoadingState: enableImgLoadingState
    }), tripSaveItem && /* @__PURE__ */ React55.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: tripSaveItemPosition,
        source: tripsPlanSource,
        showRedOutline: true
    }), (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React55.createElement(UitkLayoutPosition4, {
        type: "absolute",
        position: {
            bottom: isSmallViewport ? "four" : void 0,
            top: isSmallViewport ? void 0 : "four",
            left: "one",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(EGDSBadgesHeading, {
        data: badges,
        size: "SMALL"
    })))))), /* @__PURE__ */ React55.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: view === "LANDING" /* LANDING */  ? 1 : 2,
            medium: 2
        }
    }, /* @__PURE__ */ React55.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React55.createElement(React55.Fragment, null, (heading === null || heading === void 0 ? void 0 : heading.title) && /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(DiscoveryHeadingTitle, {
        data: heading,
        titleProps: titleProps !== null && titleProps !== void 0 ? titleProps : {
            tag: cardTitleTagProps !== null && cardTitleTagProps !== void 0 ? cardTitleTagProps : "h4",
            size: 5,
            overflow: "truncate-3-lines"
        },
        highlightProps: {
            size: 200,
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }))), starRating && /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(DiscoveryStarRating, {
        data: starRating
    }))))), (heading === null || heading === void 0 ? void 0 : heading.subTitle) && /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(DiscoveryHeadingSubtitle, {
        data: heading,
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }))), detailsList && /* @__PURE__ */ React55.createElement(EGDSDetailsList, {
        data: detailsList,
        hasMinWidth: false,
        spacing: {
            block: "two"
        }
    }), rating && /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        secondaryTextProps: {
            size: 300
        },
        supportingMessagesProps: {
            size: 200
        }
    }))), uniqueness && /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(PropertyUniqueness, {
        data: uniqueness
    })))), /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React55.createElement(React55.Fragment, null, /* @__PURE__ */ React55.createElement(UitkLayoutGrid, {
        space: "one",
        columns: {
            small: 1,
            medium: 3
        }
    }, reviewSnippet && /* @__PURE__ */ React55.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: 1,
            medium: 2
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(ReviewSnippet, {
        data: reviewSnippet
    }))))), showPrice && /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: priceExtraSpace ? "four" : "one"
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: reviewSnippet ? 1 : 2,
            medium: reviewSnippet ? 1 : 3
        },
        justifySelf: "end",
        alignSelf: "end"
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, !(badges === null || badges === void 0 ? void 0 : (_badges_priceBadge = badges.priceBadge) === null || _badges_priceBadge === void 0 ? void 0 : _badges_priceBadge.action) && (badges === null || badges === void 0 ? void 0 : (_badges_priceBadge1 = badges.priceBadge) === null || _badges_priceBadge1 === void 0 ? void 0 : _badges_priceBadge1.badge) && /* @__PURE__ */ React55.createElement(EGDSBadgesPriceBadge, {
        data: badges
    }), /* @__PURE__ */ React55.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    })))))), /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, (badges === null || badges === void 0 ? void 0 : (_badges_priceBadge2 = badges.priceBadge) === null || _badges_priceBadge2 === void 0 ? void 0 : _badges_priceBadge2.action) && /* @__PURE__ */ React55.createElement(EGDSLayoutPosition2, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(EGDSBadgesPriceBadge, {
        data: badges
    })))), (badges === null || badges === void 0 ? void 0 : (_badges_priceButton = badges.priceButton) === null || _badges_priceButton === void 0 ? void 0 : (_badges_priceButton_button = _badges_priceButton.button) === null || _badges_priceButton_button === void 0 ? void 0 : _badges_priceButton_button.action) && /* @__PURE__ */ React55.createElement(EGDSLayoutPosition2, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React55.createElement(UitkSpacing15, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(EGDSBadgesPriceAltButton, {
        data: badges
    })))))))))))), /* @__PURE__ */ React55.createElement(EGDSUICardAction, {
        data: cardAction,
        seoEntityUrl: seoEntityUrl
    })));
};
ListCard.fragment = DiscoveryCardFragment;
ListCard.displayName = "ListCard";
// ../internal/src/components/cards/long-form-featured-card.tsx
import React58 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
// ../../sponsored-content/internal/src/components/beacons/use-beacons.tsx
import React57 from "react";
import { gql as gql50 } from "@apollo/client";
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@17.0.2/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
import * as React56 from "react";
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@17.0.2/node_modules/@shared-ui/logger-context/dist/esmodule/components/system-event.js
var SystemEventLevel;
(function(SystemEventLevel2) {
    SystemEventLevel2["CRITICAL"] = "CRITICAL";
    SystemEventLevel2["ERROR"] = "ERROR";
    SystemEventLevel2["WARN"] = "WARN";
    SystemEventLevel2["INFO"] = "INFO";
    SystemEventLevel2["UNKNOWN"] = "UNKNOWN";
})(SystemEventLevel || (SystemEventLevel = {}));
var SystemEvent = /** @class */ function() {
    function SystemEvent2(level, name) {
        this.level = level;
        this.name = name;
    }
    SystemEvent2.prototype.toString = function() {
        return "SystemEvent(level=" + this.level.toString() + " name=" + this.name + ")";
    };
    return SystemEvent2;
}();
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@17.0.2/node_modules/@shared-ui/logger-context/dist/esmodule/components/logger.js
var __read = function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spread = function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
};
var Logger = /** @class */ function() {
    function Logger2(logger) {
        var _this = this;
        this.event = logger.event || function() {};
        var logAtLevel = function logAtLevel(level, message) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++){
                args[_i - 2] = arguments[_i];
            }
            if (_this.event) {
                _this.event.apply(_this, __spread([
                    new SystemEvent(level, message)
                ], args));
            }
        };
        this.info = logger.info || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.INFO,
                message
            ], args));
        };
        this.warning = logger.warning || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.WARN,
                message
            ], args));
        };
        this.error = logger.error || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.ERROR,
                message
            ], args));
        };
    }
    return Logger2;
}();
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@17.0.2/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
var defaults = new Logger({});
var LoggerContext = React56.createContext(defaults);
var LoggerProvider = function LoggerProvider(props) {
    var logger = props.logger, children = props.children;
    var value = logger ? new Logger(logger) : defaults;
    return React56.createElement(LoggerContext.Provider, {
        value: value
    }, children || null);
};
LoggerProvider.displayName = "LoggerProvider";
// ../../sponsored-content/internal/src/components/utils/logger-utils.ts
var EVENTS = {
    FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent(SystemEventLevel.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */ )
};
// ../../sponsored-content/internal/src/components/beacons/use-beacons.tsx
var SponsoredContentBeaconsFragment = gql50(_templateObject49());
var useMesoBeaconFramework = function(beacons) {
    React57.useEffect(function() {
        if (beacons) {
            beacons.forEach(function(renderBeaconUrl) {
                window.meso = window.meso || {};
                window.meso.beacons = window.meso.beacons || [];
                window.meso.beacons.push({
                    type: "beacon",
                    url: renderBeaconUrl
                });
            });
        }
    }, []);
};
// ../../sponsored-content/use-beacons-wrapper/src/components/use-beacons-wrapper/use-beacons-wrapper.tsx
var useMesoBeaconFrameworkWrapper = useMesoBeaconFramework;
// ../internal/src/components/cards/long-form-featured-card.tsx
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection6, UitkCardFeaturedHeader } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType6 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
var defaultHeadingOptions = {
    titleProps: {
        tag: "h4",
        size: 6,
        overflow: "truncate-3-lines"
    },
    subTitleProps: {
        spacing: "one",
        overflow: "truncate-3-lines"
    },
    highlightProps: {
        size: 200,
        overflow: "truncate-3-lines"
    }
};
var LongFormFeaturedCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker, headingOptions = param.headingOptions;
    var _data_render;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, detailsList = data.detailsList, badges = data.badges, rating = data.rating, uniqueness = data.uniqueness;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var headingProps = headingOptions ? shallowOverride(defaultHeadingOptions, headingOptions) : defaultHeadingOptions;
    useMesoBeaconFrameworkWrapper((_data_render = data.render) === null || _data_render === void 0 ? void 0 : _data_render.urls);
    var cardComponent = /* @__PURE__ */ React58.createElement(UitkCard7, {
        border: true
    }, /* @__PURE__ */ React58.createElement(UitkLayoutFlex15, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React58.createElement("div", null, (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React58.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            zindex: "layer1",
            top: "three",
            left: "three"
        }
    }, /* @__PURE__ */ React58.createElement(EGDSBadgesHeading, {
        data: badges
    })), (heading === null || heading === void 0 ? void 0 : heading.featuredHeader) && /* @__PURE__ */ React58.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            left: "zero",
            top: "zero",
            right: "zero",
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React58.createElement(UitkCardFeaturedHeader, {
        title: {
            tag: "h3",
            text: heading.featuredHeader
        }
    })), media && /* @__PURE__ */ React58.createElement(EGDSLayoutPosition3, {
        type: "relative"
    }, /* @__PURE__ */ React58.createElement(AdBadge, {
        data: badges
    }), /* @__PURE__ */ React58.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            roundcorner: [
                "startstart",
                "startend"
            ],
            ratio: UitkFigureAspectRatioType6.R16_9
        }
    })), /* @__PURE__ */ React58.createElement(UitkCardContentSection6, {
        padded: false
    }, /* @__PURE__ */ React58.createElement(UitkSpacing16, {
        padding: {
            inline: "three",
            blockstart: "three",
            blockend: showPrice ? "two" : "three"
        }
    }, /* @__PURE__ */ React58.createElement("div", null, heading && /* @__PURE__ */ React58.createElement(UitkSpacing16, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React58.createElement(DiscoveryHeading, _object_spread({
        data: heading
    }, headingProps))), uniqueness && /* @__PURE__ */ React58.createElement(UitkSpacing16, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(PropertyUniqueness, {
        data: uniqueness,
        isFullWidth: true,
        size: 200,
        cardPadding: "three"
    }))), detailsList && /* @__PURE__ */ React58.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSDetailsList, {
        data: detailsList,
        hasMinWidth: true
    }))), rating && /* @__PURE__ */ React58.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        showPrimaryTextPadding: true
    }))))))), showPrice && /* @__PURE__ */ React58.createElement(UitkCardContentSection6, {
        padded: [
            "blockend",
            "inlineend"
        ]
    }, /* @__PURE__ */ React58.createElement(UitkLayoutFlex15, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, (badges === null || badges === void 0 ? void 0 : badges.price) && /* @__PURE__ */ React58.createElement(EGDSBadgesPrice, {
        data: badges
    }), /* @__PURE__ */ React58.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    }))), /* @__PURE__ */ React58.createElement(EGDSUICardAction, {
        data: cardAction
    })));
    return withoutIntersectionTracker ? /* @__PURE__ */ React58.createElement(React58.Fragment, null, cardComponent) : /* @__PURE__ */ React58.createElement(UitkLayoutFlex15, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React58.createElement(UitkLayoutFlexItem9, {
        grow: 1
    }, /* @__PURE__ */ React58.createElement(IntersectionTracker6, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent)));
};
LongFormFeaturedCard.fragment = DiscoveryCardFragment;
LongFormFeaturedCard.displayName = "LongFormFeaturedCard";
// ../internal/src/components/cards/landing-card.tsx
import React59 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { IntersectionTracker as IntersectionTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard8, UitkCardContentSection as UitkCardContentSection7 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
var LandingCard = function(param) {
    var data = param.data, withoutIntersectionTracker = param.withoutIntersectionTracker, cardTitleTagProps = param.cardTitleTagProps;
    var _badges_priceBadge, _badges_priceBadge1, _badges_priceBadge2;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, impression = data.impression, legacyPrice = data.legacyPrice, detailsList = data.detailsList, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem, starRating = data.starRating, seoEntityUrl = data.seoEntityUrl, uniqueness = data.uniqueness, reviewSnippet = data.reviewSnippet;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    var cardComponent = /* @__PURE__ */ React59.createElement(UitkCard8, {
        border: true,
        backgroundTheme: "primary"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlex16, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem10, {
        grow: 1
    }, /* @__PURE__ */ React59.createElement("div", null, (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React59.createElement(UitkLayoutPosition6, {
        type: "absolute",
        position: {
            zindex: "layer1",
            top: "three",
            left: "three"
        }
    }, /* @__PURE__ */ React59.createElement(EGDSBadgesHeading, {
        data: badges
    })), media && /* @__PURE__ */ React59.createElement(DiscoveryCardMedia, {
        data: media,
        figureProps: {
            roundcorner: [
                "startstart",
                "startend"
            ],
            imageFit: "cover"
        },
        imageLink: cardAction
    }), tripSaveItem && /* @__PURE__ */ React59.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer2"
            }
        },
        showRedOutline: true
    }), /* @__PURE__ */ React59.createElement(UitkCardContentSection7, {
        padded: true
    }, heading && /* @__PURE__ */ React59.createElement(DiscoveryHeading, {
        data: heading,
        titleProps: {
            tag: cardTitleTagProps !== null && cardTitleTagProps !== void 0 ? cardTitleTagProps : "h3",
            size: 6,
            overflow: "truncate-3-lines"
        },
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-3-lines"
        },
        highlightProps: {
            size: 200,
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }, starRating && /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React59.createElement(UitkSpacing17, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React59.createElement(DiscoveryStarRating, {
        data: starRating
    })))), detailsList && /* @__PURE__ */ React59.createElement(EGDSDetailsList, {
        data: detailsList,
        spacing: {
            block: "two"
        },
        hasMinWidth: false
    })), rating && /* @__PURE__ */ React59.createElement(UitkCardContentSection7, {
        padded: uniqueness ? [
            "inlinestart"
        ] : [
            "blockend",
            "inlinestart"
        ]
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlex16, {
        space: "one",
        direction: "column",
        alignItems: "start"
    }, /* @__PURE__ */ React59.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        secondaryTextProps: {
            size: 300
        },
        supportingMessagesProps: {
            size: 200
        }
    }))), uniqueness && /* @__PURE__ */ React59.createElement(UitkSpacing17, {
        padding: "three"
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(PropertyUniqueness, {
        data: uniqueness
    }))), reviewSnippet && /* @__PURE__ */ React59.createElement(UitkSpacing17, {
        margin: "three"
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(ReviewSnippet, {
        data: reviewSnippet
    }))))), (badges === null || badges === void 0 ? void 0 : (_badges_priceBadge = badges.priceBadge) === null || _badges_priceBadge === void 0 ? void 0 : _badges_priceBadge.action) && /* @__PURE__ */ React59.createElement(UitkSpacing17, {
        padding: "three"
    }, /* @__PURE__ */ React59.createElement(EGDSLayoutPosition4, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlex16, {
        space: "two",
        direction: "column",
        alignItems: "start"
    }, /* @__PURE__ */ React59.createElement(EGDSBadgesPriceBadge, {
        data: badges
    })))), showPrice && /* @__PURE__ */ React59.createElement(UitkCardContentSection7, {
        padded: [
            "blockend",
            "inlineend"
        ]
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlex16, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, !(badges === null || badges === void 0 ? void 0 : (_badges_priceBadge1 = badges.priceBadge) === null || _badges_priceBadge1 === void 0 ? void 0 : _badges_priceBadge1.action) && (badges === null || badges === void 0 ? void 0 : (_badges_priceBadge2 = badges.priceBadge) === null || _badges_priceBadge2 === void 0 ? void 0 : _badges_priceBadge2.badge) && /* @__PURE__ */ React59.createElement(EGDSBadgesPriceBadge, {
        data: badges
    }), /* @__PURE__ */ React59.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    }))), /* @__PURE__ */ React59.createElement(EGDSUICardAction, {
        data: cardAction,
        seoEntityUrl: seoEntityUrl
    })));
    return withoutIntersectionTracker ? /* @__PURE__ */ React59.createElement(React59.Fragment, null, cardComponent) : /* @__PURE__ */ React59.createElement(UitkLayoutFlex16, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem10, {
        grow: 1
    }, /* @__PURE__ */ React59.createElement(IntersectionTracker7, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, cardComponent)));
};
LandingCard.fragment = DiscoveryCardFragment;
LandingCard.displayName = "LandingCard";
// ../internal/src/components/cards/smart-landing-card.tsx
import React60 from "react";
import { IntersectionTracker as IntersectionTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard9, UitkCardContentSection as UitkCardContentSection8 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition7 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
var SmartLandingCard = function(param) {
    var data = param.data, _param_border = param.border, border = _param_border === void 0 ? true : _param_border, priceExtraSpace = param.priceExtraSpace, titleProps = param.titleProps, _param_carouselLoop = param.carouselLoop, carouselLoop = _param_carouselLoop === void 0 ? false : _param_carouselLoop;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, legacyPrice = data.legacyPrice, impression = data.impression, badges = data.badges, rating = data.rating, tripSaveItem = data.tripSaveItem, starRating = data.starRating, reviewSnippet = data.reviewSnippet, uniqueness = data.uniqueness, detailsList = data.detailsList;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = (legacyPrice === null || legacyPrice === void 0 ? void 0 : legacyPrice.displayMessages) && legacyPrice.displayMessages.length !== 0;
    return /* @__PURE__ */ React60.createElement(IntersectionTracker8, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, /* @__PURE__ */ React60.createElement(UitkCard9, {
        border: border
    }, /* @__PURE__ */ React60.createElement(UitkLayoutGrid2, {
        columns: {
            medium: 3
        }
    }, /* @__PURE__ */ React60.createElement(UitkLayoutPosition7, {
        type: "relative"
    }, /* @__PURE__ */ React60.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React60.createElement(UitkLayoutFlex17, {
        blockSize: "full_size"
    }, media && /* @__PURE__ */ React60.createElement(DiscoveryCardMedia, {
        data: media,
        showAttribution: false,
        figureProps: {
            imageFit: "cover"
        },
        carouselLoop: carouselLoop,
        imageLink: cardAction
    }), tripSaveItem && /* @__PURE__ */ React60.createElement(DiscoveryTripSaveItem, {
        data: tripSaveItem,
        position: {
            type: "absolute",
            position: {
                top: "one",
                right: "one",
                zindex: "layer2"
            }
        }
    })))), /* @__PURE__ */ React60.createElement(UitkLayoutGridItem2, {
        colSpan: {
            medium: 2
        }
    }, /* @__PURE__ */ React60.createElement(UitkCardContentSection8, null, /* @__PURE__ */ React60.createElement(UitkLayoutFlex17, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React60.createElement(React60.Fragment, null, (heading === null || heading === void 0 ? void 0 : heading.title) && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(DiscoveryHeadingTitle, {
        data: heading,
        titleProps: titleProps !== null && titleProps !== void 0 ? titleProps : {
            tag: "h4",
            size: 5,
            overflow: "truncate-3-lines"
        },
        highlightProps: {
            size: 200,
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }))), starRating && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(UitkSpacing18, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(DiscoveryStarRating, {
        data: starRating
    }))))), (heading === null || heading === void 0 ? void 0 : heading.subTitle) && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(DiscoveryHeadingSubtitle, {
        data: heading,
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-3-lines"
        },
        ariaHidden: true
    }))), detailsList && /* @__PURE__ */ React60.createElement(EGDSDetailsList, {
        data: detailsList,
        spacing: {
            block: "two"
        }
    }), rating && /* @__PURE__ */ React60.createElement(UitkSpacing18, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(EGDSRating, {
        data: rating,
        primaryTextProps: {
            weight: "bold",
            theme: "emphasis",
            size: 400
        },
        secondaryTextProps: {
            size: 300
        },
        supportingMessagesProps: {
            size: 200
        }
    }))), uniqueness && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React60.createElement(UitkSpacing18, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(PropertyUniqueness, {
        data: uniqueness
    })))), /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React60.createElement(UitkLayoutGrid2, {
        space: "one",
        columns: {
            small: 1,
            medium: 3
        }
    }, reviewSnippet && /* @__PURE__ */ React60.createElement(UitkLayoutGridItem2, {
        colSpan: {
            small: 1,
            medium: 2
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(UitkSpacing18, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(ReviewSnippet, {
        data: reviewSnippet
    }))))), showPrice && /* @__PURE__ */ React60.createElement(UitkSpacing18, {
        margin: {
            blockstart: priceExtraSpace ? "four" : "one"
        }
    }, /* @__PURE__ */ React60.createElement(UitkLayoutGridItem2, {
        colSpan: {
            small: reviewSnippet ? 1 : 2,
            medium: reviewSnippet ? 1 : 3
        },
        justifySelf: "end",
        alignSelf: "end"
    }, /* @__PURE__ */ React60.createElement(UitkLayoutFlex17, {
        space: "one",
        direction: "column",
        alignItems: "end"
    }, (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React60.createElement(EGDSBadgesHeading, {
        data: badges
    }), (badges === null || badges === void 0 ? void 0 : badges.price) && /* @__PURE__ */ React60.createElement(EGDSBadgesPrice, {
        data: badges
    }), /* @__PURE__ */ React60.createElement(LegacyPrice, {
        data: legacyPrice,
        flexAlignment: "end"
    }))))))))))), /* @__PURE__ */ React60.createElement(EGDSUICardAction, {
        data: cardAction
    })));
};
SmartLandingCard.fragment = DiscoveryCardFragment;
SmartLandingCard.displayName = "SmartLandingCard";
var _obj10;
// ../internal/src/components/utils/card-content-size-mapper.ts
var DiscoveryCardSizeMapping = (_obj10 = {}, _define_property(_obj10, "FOUNDATION" /* FOUNDATION */ , FoundationCard), _define_property(_obj10, "FOUNDATION_DETAILS_LIST" /* FOUNDATION_DETAILS_LIST */ , FoundationCard), _define_property(_obj10, "ABBREVIATED" /* ABBREVIATED */ , AbbreviatedCard), _define_property(_obj10, "UBER_ABBREVIATED" /* UBER_ABBREVIATED */ , UberAbbreviatedCard), _define_property(_obj10, "UBER_ABBREVIATED_PRICE" /* UBER_ABBREVIATED_PRICE */ , UberAbbreviatedCard), _define_property(_obj10, "UBER_ABBREVIATED_RATING" /* UBER_ABBREVIATED_RATING */ , UberAbbreviatedCard), _define_property(_obj10, "LONG_FORM" /* LONG_FORM */ , LongFormCard), _define_property(_obj10, "LONG_FORM_FEATURED" /* LONG_FORM_FEATURED */ , LongFormFeaturedCard), _define_property(_obj10, "LANDING" /* LANDING */ , LandingCard), _define_property(_obj10, "SMART_LANDING" /* SMART_LANDING */ , SmartLandingCard), _obj10);
var DiscoveryListSizeMapping = _define_property({}, "SMART_LANDING" /* SMART_LANDING */ , SmartLandingCard);
var _obj11;
var themeProperties = (_obj11 = {}, _define_property(_obj11, "FOUNDATION" /* FOUNDATION */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _define_property(_obj11, "FOUNDATION_DETAILS_LIST" /* FOUNDATION_DETAILS_LIST */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _define_property(_obj11, "ABBREVIATED" /* ABBREVIATED */ , {
    itemsVisible: {
        sm: 2,
        md: 4,
        lg: 5,
        xl: 5
    },
    columns: {
        small: 2,
        medium: 4,
        large: 5
    }
}), _define_property(_obj11, "UBER_ABBREVIATED" /* UBER_ABBREVIATED */ , {
    itemsVisible: {
        sm: 2,
        md: 4,
        lg: 5,
        xl: 5
    },
    columns: {
        small: 2,
        medium: 4,
        large: 5
    }
}), _define_property(_obj11, "UBER_ABBREVIATED_PRICE" /* UBER_ABBREVIATED_PRICE */ , {
    itemsVisible: {
        sm: 2,
        md: 4,
        lg: 5,
        xl: 5
    },
    columns: {
        small: 2,
        medium: 4,
        large: 5
    }
}), _define_property(_obj11, "UBER_ABBREVIATED_RATING" /* UBER_ABBREVIATED_RATING */ , {
    itemsVisible: {
        sm: 2,
        md: 4,
        lg: 5,
        xl: 5
    },
    columns: {
        small: 2,
        medium: 4,
        large: 5
    }
}), _define_property(_obj11, "LONG_FORM" /* LONG_FORM */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _define_property(_obj11, "LONG_FORM_FEATURED" /* LONG_FORM_FEATURED */ , {
    itemsVisible: {
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _define_property(_obj11, "LANDING" /* LANDING */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _define_property(_obj11, "SMART_LANDING" /* SMART_LANDING */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    }
}), _obj11);
// ../internal/src/components/utils/card-title-tag-mapper.ts
var titlePropMap = {
    h1: "h2",
    h2: "h3",
    h3: "h4",
    h4: "h5",
    h5: "h6"
};
var getCardTitleTag = function(titleTag) {
    return titleTag ? titlePropMap[titleTag] : void 0;
};
// ../internal/src/components/discovery-container/discovery-container.tsx
import React66 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
// ../internal/src/components/discovery-group-layout/discovery-group-layout.tsx
import React63 from "react";
import { gql as gql54 } from "@apollo/client";
// ../internal/src/components/discovery-grid/discovery-grid.tsx
import React61 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSLayoutGrid } from "@egds/react-core/layout-grid";
// ../internal/src/components/utils/fragments/discovery-viewport-items.ts
import { gql as gql51 } from "@apollo/client";
var DiscoveryViewportItemsFragment = gql51(_templateObject50());
// ../internal/src/components/discovery-grid/discovery-grid.tsx
var __fragment32 = gql52(_templateObject51(), DiscoveryViewportItemsFragment);
var DiscoveryGrid = function(param) {
    var children = param.children, data = param.data;
    if (!Array.isArray(children) || children.length === 0 || !(data === null || data === void 0 ? void 0 : data.columns)) {
        return null;
    }
    var columns = data.columns;
    return /* @__PURE__ */ React61.createElement(EGDSLayoutGrid, {
        columns: columns,
        space: "three",
        "data-testid": "discovery-grid"
    }, children);
};
DiscoveryGrid.fragment = __fragment32;
DiscoveryGrid.displayName = "DiscoveryGrid";
// ../internal/src/components/discovery-list/discovery-list.tsx
import React62 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid3 } from "uitk-react-layout-grid";
var __fragment33 = gql53(_templateObject52());
var DiscoveryList = function(param) {
    var children = param.children;
    if (!Array.isArray(children) || children.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React62.createElement(UitkLayoutGrid3, {
        columns: 1,
        space: "three",
        justifyContent: "space-between",
        "data-testid": "discovery-list"
    }, children);
};
DiscoveryList.fragment = __fragment33;
DiscoveryList.displayName = "DiscoveryList";
// ../internal/src/components/discovery-group-layout/discovery-group-layout.tsx
var __fragment34 = gql54(_templateObject53(), DiscoveryList.fragment, DiscoveryGrid.fragment, EGDSCarousel.fragment);
var DiscoveryGroupLayout = function(param) {
    var data = param.data, itemsVisible = param.itemsVisible, children = param.children;
    var __typename = data.__typename;
    if (!Array.isArray(children) || children.length === 0) {
        return null;
    }
    switch(__typename){
        case "EGDSCarousel":
            return /* @__PURE__ */ React63.createElement(EGDSCarousel, {
                data: data,
                itemsVisible: itemsVisible,
                peek: true
            }, children);
        case "DiscoveryList":
            return /* @__PURE__ */ React63.createElement(DiscoveryList, {
                data: data
            }, children);
        case "DiscoveryGrid":
            return /* @__PURE__ */ React63.createElement(DiscoveryGrid, {
                data: data
            }, children);
        default:
            return null;
    }
};
DiscoveryGroupLayout.fragment = __fragment34;
DiscoveryGroupLayout.displayName = "DiscoveryGroupLayout";
// ../internal/src/components/discovery-wrapper/discovery-wrapper.tsx
import React65 from "react";
import { gql as gql56 } from "@apollo/client";
// ../internal/src/components/discovery-expando/discovery-expando.tsx
import React64, { useRef } from "react";
import { gql as gql55 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useViewportMap, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
// ../internal/src/components/utils/scroll.ts
var scrollToElement = function(element) {
    if (element.current) {
        var rect = element.current.getBoundingClientRect();
        var absoluteTop = window.scrollY + rect.top;
        window.scroll({
            top: absoluteTop,
            left: 0,
            behavior: "smooth"
        });
    }
};
// ../internal/src/components/discovery-expando/discovery-expando.tsx
var __fragment35 = gql55(_templateObject54(), DiscoveryViewportItemsFragment, EGDSExpandoPeek.fragment);
var DiscoveryExpando = function(param) {
    var children = param.children, data = param.data, className = param.className;
    var expando = data.expando, items = data.items;
    var _React64_useState = _sliced_to_array(React64.useState((expando === null || expando === void 0 ? void 0 : expando.expanded) || false), 2), isVisible = _React64_useState[0], setIsVisible = _React64_useState[1];
    var clickTracker = useClickTracker11();
    var triggerBtn = useRef(null);
    var visiblePart = useRef(null);
    var handleClickAction = React64.useCallback(function() {
        if (expando) {
            var expandAnalytics = expando.expandAnalytics, collapseAnalytics = expando.collapseAnalytics;
            var expandoReferrerId = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId;
            var expandoLinkName = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName;
            if (expandoReferrerId && expandoLinkName) {
                clickTracker(expandoReferrerId, expandoLinkName);
            }
        }
        if (isVisible) {
            if (visibleChildren) {
                scrollToElement(visiblePart);
            } else {
                scrollToElement(triggerBtn);
            }
        }
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var _obj;
    var itemsViewport = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes2.SMALL, items.small), _define_property(_obj, ViewSizes2.MEDIUM, items.medium), _define_property(_obj, ViewSizes2.LARGE, items.large), _obj));
    if (!children) {
        return null;
    }
    if (!expando) {
        return /* @__PURE__ */ React64.createElement(React64.Fragment, null, children);
    }
    var childCount = React64.Children.count(children);
    var isSingleChild = childCount === 1 && React64.isValidElement(children);
    var singleChild = isSingleChild ? children : void 0;
    if (!isSingleChild && !Array.isArray(children)) {
        return null;
    }
    var actualChildren = isSingleChild ? children.props.children : children;
    if (!actualChildren || !Array.isArray(actualChildren)) {
        return null;
    }
    var visibleChildren = actualChildren.slice(0, itemsViewport);
    var hiddenChildren = actualChildren.slice(itemsViewport, actualChildren.length);
    var collapsedLabel = expando.collapsedLabel, expandedLabel = expando.expandedLabel;
    var hiddenChildrenComponent = isSingleChild ? React64.cloneElement(singleChild, {
        children: hiddenChildren
    }) : hiddenChildren;
    return expando && hiddenChildren.length > 0 && itemsViewport !== 0 ? /* @__PURE__ */ React64.createElement(React64.Fragment, null, /* @__PURE__ */ React64.createElement("div", {
        ref: visiblePart
    }, isSingleChild && visibleChildren ? React64.cloneElement(singleChild, {
        children: visibleChildren
    }) : visibleChildren), /* @__PURE__ */ React64.createElement(EGDSSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React64.createElement("div", {
        className: className,
        ref: triggerBtn
    }, !isVisible ? /* @__PURE__ */ React64.createElement("div", {
        "data-testid": "discovery-expando",
        className: "is-visually-hidden"
    }, hiddenChildrenComponent) : hiddenChildrenComponent, /* @__PURE__ */ React64.createElement(EGDSSpacing, {
        padding: {
            blockstart: isVisible ? "six" : "three"
        }
    }, /* @__PURE__ */ React64.createElement(EGDSLink, {
        onClick: handleClickAction,
        id: "discovery-expando-trigger"
    }, /* @__PURE__ */ React64.createElement("button", {
        type: "button"
    }, isVisible ? expandedLabel : collapsedLabel, " ", /* @__PURE__ */ React64.createElement(EGDSIcon2, {
        name: !isVisible ? "expand_more" : "expand_less"
    }))))))) : /* @__PURE__ */ React64.createElement(React64.Fragment, null, children);
};
DiscoveryExpando.fragment = __fragment35;
DiscoveryExpando.displayName = "DiscoveryExpando";
// ../internal/src/components/discovery-wrapper/discovery-wrapper.tsx
var __fragment36 = gql56(_templateObject55(), DiscoveryExpando.fragment);
var DiscoveryWrapper = function(param) {
    var data = param.data, children = param.children, className = param.className;
    if (!data) {
        return /* @__PURE__ */ React65.createElement(React65.Fragment, null, children);
    }
    var __typename = data.__typename;
    switch(__typename){
        case "DiscoveryExpando":
            return /* @__PURE__ */ React65.createElement(DiscoveryExpando, {
                className: className,
                data: data
            }, children);
        default:
            return /* @__PURE__ */ React65.createElement(React65.Fragment, null, children);
    }
};
DiscoveryWrapper.fragment = __fragment36;
DiscoveryWrapper.displayName = "DiscoveryWrapper";
// ../internal/src/components/discovery-container/discovery-container.tsx
var __fragment37 = gql57(_templateObject56(), DiscoveryGroupLayout.fragment, DiscoveryWrapper.fragment, DiscoveryCardFragment);
var DiscoveryContainer = function(param) {
    var data = param.data, cardTheme = param.cardTheme, children = param.children, cardTitleTagProps = param.cardTitleTagProps, injectedComponents = param.injectedComponents;
    var itemsLayout = data.itemsLayout, wrapper = data.wrapper;
    var DiscoveryCard;
    var itemsVisible;
    if (typeof cardTheme === "string") {
        DiscoveryCard = DiscoveryCardSizeMapping[cardTheme];
        if (itemsLayout.__typename === "DiscoveryList") {
            var _themeProperties_cardTheme;
            DiscoveryCard = DiscoveryListSizeMapping[cardTheme] ? DiscoveryListSizeMapping[cardTheme] : ListCard;
            itemsVisible = ((_themeProperties_cardTheme = themeProperties[cardTheme]) === null || _themeProperties_cardTheme === void 0 ? void 0 : _themeProperties_cardTheme.itemsVisible) || themeProperties.FOUNDATION.itemsVisible;
        }
    } else {
        DiscoveryCard = cardTheme;
        itemsVisible = themeProperties.FOUNDATION.itemsVisible;
    }
    if (!Array.isArray(children) || children.length === 0) {
        return null;
    }
    return wrapper ? /* @__PURE__ */ React66.createElement(DiscoveryWrapper, {
        data: wrapper
    }, /* @__PURE__ */ React66.createElement(DiscoveryGroupLayout, {
        data: itemsLayout,
        itemsVisible: itemsVisible
    }, children.map(function(card, index) {
        return /* @__PURE__ */ React66.createElement(React66.Fragment, {
            key: index
        }, itemsLayout.__typename === "DiscoveryList" ? injectedComponents === null || injectedComponents === void 0 ? void 0 : injectedComponents.map(function(item) {
            return index === item.index ? item.component : null;
        }) : null, itemsLayout.__typename !== "EGDSCarousel" ? /* @__PURE__ */ React66.createElement(UitkLayoutGridItem3, null, DiscoveryCard && /* @__PURE__ */ React66.createElement(DiscoveryCard, {
            data: card,
            cardTitleTagProps: cardTitleTagProps
        })) : DiscoveryCard && /* @__PURE__ */ React66.createElement(DiscoveryCard, {
            data: card,
            cardTitleTagProps: cardTitleTagProps
        }));
    }))) : /* @__PURE__ */ React66.createElement(DiscoveryGroupLayout, {
        data: itemsLayout,
        itemsVisible: itemsVisible
    }, children.map(function(card, index) {
        return /* @__PURE__ */ React66.createElement(React66.Fragment, {
            key: index
        }, itemsLayout.__typename === "DiscoveryList" ? injectedComponents === null || injectedComponents === void 0 ? void 0 : injectedComponents.map(function(item) {
            return index === item.index ? item.component : null;
        }) : null, itemsLayout.__typename !== "EGDSCarousel" ? /* @__PURE__ */ React66.createElement(UitkLayoutGridItem3, null, DiscoveryCard && /* @__PURE__ */ React66.createElement(DiscoveryCard, {
            data: card,
            cardTitleTagProps: cardTitleTagProps
        })) : DiscoveryCard && /* @__PURE__ */ React66.createElement(DiscoveryCard, {
            data: card,
            cardTitleTagProps: cardTitleTagProps
        }));
    }));
};
DiscoveryContainer.fragment = __fragment37;
DiscoveryContainer.displayName = "DiscoveryContainer";
// ../internal/src/components/discovery-group-container/discovery-group-container.tsx
var __fragment38 = gql58(_templateObject57(), DiscoveryContainer.fragment, EGDSCarousel.fragment, DiscoveryCardFragment);
var DiscoveryGroupContainer = function(param) {
    var data = param.data, cardTheme = param.cardTheme, carouselItemViewedCallback = param.carouselItemViewedCallback, withoutIntersectionTracker = param.withoutIntersectionTracker, lineOfBusiness = param.lineOfBusiness, injectedComponents = param.injectedComponents, titleProps = param.titleProps, layoutOptions = param.layoutOptions, onHoverChanged = param.onHoverChanged;
    var container = data.container, cards = data.cards;
    var _ref = layoutOptions || {}, itemsVisibleProp = _ref.itemsVisible, peekProp = _ref.peek, cardOptions = _ref.cardOptions;
    var peek = useViewportMap2(peekModifier(peekProp));
    if (!Array.isArray(cards) || cards.length === 0) {
        return null;
    }
    var DiscoveryCard;
    var itemsVisible;
    var columns;
    if (typeof cardTheme === "string") {
        var _themeProperties_cardTheme, _themeProperties_cardTheme1;
        DiscoveryCard = DiscoveryCardSizeMapping[cardTheme];
        itemsVisible = itemsVisibleProp || ((_themeProperties_cardTheme = themeProperties[cardTheme]) === null || _themeProperties_cardTheme === void 0 ? void 0 : _themeProperties_cardTheme.itemsVisible);
        columns = (_themeProperties_cardTheme1 = themeProperties[cardTheme]) === null || _themeProperties_cardTheme1 === void 0 ? void 0 : _themeProperties_cardTheme1.columns;
    } else {
        DiscoveryCard = cardTheme;
        itemsVisible = itemsVisibleProp || themeProperties.FOUNDATION.itemsVisible;
        columns = themeProperties.FOUNDATION.columns;
    }
    var fireImpressionBeacon = React67.useCallback(function(index) {
        var _item_impression;
        var item = data === null || data === void 0 ? void 0 : data.cards[index];
        var impressionUrls = item === null || item === void 0 ? void 0 : (_item_impression = item.impression) === null || _item_impression === void 0 ? void 0 : _item_impression.urls;
        if (impressionUrls && impressionUrls.length > 0) {
            fetch(impressionUrls[0]).catch(function(err) {
                return err;
            });
        }
    }, [
        data
    ]);
    var carouselItemViewedCallbackHandler = function(index) {
        carouselItemViewedCallback === null || carouselItemViewedCallback === void 0 ? void 0 : carouselItemViewedCallback(index);
        fireImpressionBeacon(index);
    };
    var shouldHideNavOnMobile = cardTheme === "LANDING" /* LANDING */ ;
    switch(container === null || container === void 0 ? void 0 : container.__typename){
        case "EGDSCarousel":
            {
                var renderCarousel = function(additionalProps) {
                    return /* @__PURE__ */ React67.createElement(EGDSCarousel, {
                        data: container,
                        itemsVisible: itemsVisible,
                        peek: peek,
                        itemViewedCallback: carouselItemViewedCallbackHandler,
                        hideNav: additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.hideNav,
                        enableTracking: true
                    }, cards.map(function(card, index) {
                        return DiscoveryCard && /* @__PURE__ */ React67.createElement(DiscoveryCard, {
                            onHoverChanged: onHoverChanged,
                            data: card,
                            key: index,
                            withoutIntersectionTracker: withoutIntersectionTracker,
                            outputLineOfBusiness: lineOfBusiness,
                            cardTitleTagProps: getCardTitleTag(titleProps === null || titleProps === void 0 ? void 0 : titleProps.tag),
                            headingOptions: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.headingOptions
                        });
                    }));
                };
                return /* @__PURE__ */ React67.createElement(Viewport, null, /* @__PURE__ */ React67.createElement(ViewSmall, null, renderCarousel({
                    hideNav: shouldHideNavOnMobile
                })), /* @__PURE__ */ React67.createElement(ViewMedium, null, renderCarousel()));
            }
        case "DiscoveryContainer":
            return /* @__PURE__ */ React67.createElement(DiscoveryContainer, {
                data: container,
                cardTheme: cardTheme,
                injectedComponents: injectedComponents,
                cardTitleTagProps: getCardTitleTag(titleProps === null || titleProps === void 0 ? void 0 : titleProps.tag)
            }, cards);
        default:
            return /* @__PURE__ */ React67.createElement(UitkLayoutGrid4, {
                columns: columns,
                space: "three",
                rows: 2,
                justifyContent: "space-between"
            }, cards.map(function(card, index) {
                return /* @__PURE__ */ React67.createElement(UitkLayoutGridItem4, {
                    key: index
                }, DiscoveryCard && /* @__PURE__ */ React67.createElement(DiscoveryCard, {
                    data: card,
                    outputLineOfBusiness: lineOfBusiness
                }));
            }));
    }
};
DiscoveryGroupContainer.fragment = __fragment38;
DiscoveryGroupContainer.displayName = "DiscoveryGroupContainer";
// ../internal/src/components/discovery-items-group/discovery-footer.tsx
import React74 from "react";
import { gql as gql66 } from "@apollo/client";
// ../internal/src/components/discovery-footer-section/discovery-footer-section.tsx
import React70 from "react";
import { gql as gql62 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
// ../internal/src/components/utils/uitk-layout-flex-utils.ts
var UITK_LAYOUT_FLEX_ALIGN_ITEM = [
    "center",
    "end",
    "start",
    "stretch"
];
var isValidUitkLayoutFlexAlignItem = function(value) {
    return UITK_LAYOUT_FLEX_ALIGN_ITEM.includes(value);
};
// ../internal/src/components/discovery-footer-action/discovery-footer-action.tsx
import React69 from "react";
import { gql as gql61 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
// ../internal/src/components/egds-button/egds-secondary-button.tsx
import React68 from "react";
import { gql as gql60 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkSecondaryButton } from "uitk-react-button";
// ../internal/src/components/egds-button/egds-button-fragment.ts
import { gql as gql59 } from "@apollo/client";
var EGDSButtonFragment = gql59(_templateObject58(), EGDSIcon.fragment, ClientSideAnalyticsFragment);
// ../internal/src/components/egds-button/egds-secondary-button.tsx
var __Fragment = gql60(_templateObject59(), EGDSButtonFragment, ClientSideAnalyticsFragment);
var EGDSSecondaryButton = function(param) {
    var data = param.data, overrideUseRelativePath = param.overrideUseRelativePath, onClick = param.onClick, size = param.size, _param_floating = param.floating, floating = _param_floating === void 0 ? false : _param_floating;
    var primary = data.primary, analytics = data.analytics, disabled = data.disabled, actionLink = data.actionLink, icon = data.icon;
    var track = useClickTracker12();
    var linkProps = deriveLinkProps(actionLink, overrideUseRelativePath);
    var handleClick = React68.useCallback(function() {
        var analyticsData = analytics !== null && analytics !== void 0 ? analytics : actionLink === null || actionLink === void 0 ? void 0 : actionLink.analytics;
        if (analyticsData) {
            var referrerId = analyticsData.referrerId, linkName = analyticsData.linkName;
            track(referrerId, linkName);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        analytics,
        onClick,
        track,
        actionLink
    ]);
    var SecondaryButtonProps = {
        onClick: handleClick,
        disabled: disabled,
        size: size || UitkButtonSize.LARGE
    };
    var SecondaryButtonPropsWithLink = _object_spread({}, SecondaryButtonProps, linkProps);
    var currentTarget = "";
    if ((actionLink === null || actionLink === void 0 ? void 0 : actionLink.__typename) === "UILinkAction") {
        currentTarget = (actionLink === null || actionLink === void 0 ? void 0 : actionLink.target) === "INTERNAL" ? "_self" : "_blank";
    }
    return /* @__PURE__ */ React68.createElement(React68.Fragment, null, actionLink ? /* @__PURE__ */ React68.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
        target: currentTarget
    }), /* @__PURE__ */ React68.createElement(UitkSecondaryButton, _object_spread({}, SecondaryButtonProps), primary, icon && /* @__PURE__ */ React68.createElement(EGDSIcon, {
        data: icon
    }))) : /* @__PURE__ */ React68.createElement(UitkSecondaryButton, _object_spread({}, SecondaryButtonPropsWithLink), primary, icon && /* @__PURE__ */ React68.createElement(EGDSIcon, {
        data: icon
    })));
};
EGDSSecondaryButton.displayName = "EGDSSecondaryButton";
EGDSSecondaryButton.fragment = __Fragment;
// ../internal/src/components/discovery-footer-action/discovery-footer-action.tsx
var __fragment39 = gql61(_templateObject60(), EGDSSecondaryButton.fragment, EGDSStandardLink.fragment);
var DiscoveryFooterAction = function(param) {
    var data = param.data, overrideUseRelativePath = param.overrideUseRelativePath;
    if (!data) {
        return null;
    }
    switch(data.__typename){
        case "UISecondaryButton":
            return /* @__PURE__ */ React69.createElement(EGDSSecondaryButton, {
                size: UitkButtonSize2.MEDIUM,
                data: data,
                overrideUseRelativePath: overrideUseRelativePath
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React69.createElement(EGDSStandardLink, {
                data: data,
                showIcon: true
            });
        default:
            return null;
    }
};
DiscoveryFooterAction.fragment = __fragment39;
DiscoveryFooterAction.displayName = "DiscoveryFooterAction";
// ../internal/src/components/discovery-footer-section/discovery-footer-section.tsx
var __fragment40 = gql62(_templateObject61(), EGDSText.fragment, DiscoveryFooterAction.fragment);
var DiscoveryFooterSection = function(param) {
    var data = param.data, _param_align = param.align, align = _param_align === void 0 ? "center" : _param_align, margin = param.margin, isMultiElement = param.isMultiElement;
    var isAttach = useDiscoveryFooterContext().isAttach;
    var title = data.title, subtitle = data.subtitle, action = data.action, disclaimerText = data.disclaimerText, alignment = data.alignment;
    var buttonAlignment = alignment && isValidUitkLayoutFlexAlignItem(alignment) ? alignment : "center";
    var footerSpacingDisclaimer = disclaimerText ? {
        blockstart: "four",
        blockend: "three"
    } : {
        block: "four"
    };
    var actionSpacingSingleElement = disclaimerText ? {
        blockstart: "three",
        blockend: "unset"
    } : {
        block: "three"
    };
    var actionSpacingMultiElement = {
        blockstart: "four",
        blockend: "unset"
    };
    var actionSpacing = isMultiElement ? actionSpacingMultiElement : actionSpacingSingleElement;
    var footerSpacingSingleElement = (margin !== null && margin !== void 0 ? margin : isAttach) ? {
        blockstart: "three"
    } : footerSpacingDisclaimer;
    var footerSpacingMultiElement = {
        blockstart: "unset"
    };
    var footerSpacing = isMultiElement ? footerSpacingMultiElement : footerSpacingSingleElement;
    return /* @__PURE__ */ React70.createElement(React70.Fragment, null, /* @__PURE__ */ React70.createElement(EGDSSpacing2, {
        margin: footerSpacing
    }, /* @__PURE__ */ React70.createElement(EGDSLayoutFlex4, {
        alignItems: (action === null || action === void 0 ? void 0 : action.__typename) === "UISecondaryButton" ? buttonAlignment : "start",
        direction: "column",
        justifyContent: "start"
    }, title && /* @__PURE__ */ React70.createElement(EGDSSpacing2, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React70.createElement("div", null, /* @__PURE__ */ React70.createElement(EGDSText, {
        textSize: 300,
        textWeight: "bold",
        theme: "emphasis",
        data: title
    }))), subtitle && /* @__PURE__ */ React70.createElement(EGDSText, {
        textSize: 300,
        theme: "standard",
        data: subtitle
    }), action && (isAttach ? /* @__PURE__ */ React70.createElement(DiscoveryFooterAction, {
        data: action,
        overrideUseRelativePath: true
    }) : /* @__PURE__ */ React70.createElement(EGDSSpacing2, {
        margin: actionSpacing
    }, /* @__PURE__ */ React70.createElement("div", null, /* @__PURE__ */ React70.createElement(DiscoveryFooterAction, {
        data: action,
        overrideUseRelativePath: true
    })))))), disclaimerText && /* @__PURE__ */ React70.createElement(EGDSText, {
        align: align !== null && align !== void 0 ? align : "center",
        textSize: 200,
        theme: "standard",
        data: disclaimerText
    }));
};
DiscoveryFooterSection.fragment = __fragment40;
DiscoveryFooterSection.displayName = "DiscoveryFooterSection";
// ../internal/src/components/discovery-slim-card/discovery-slim-card.tsx
import React73 from "react";
import { gql as gql65 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection9 } from "uitk-react-cards";
import { UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex18, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// ../internal/src/components/discovery-text/discovery-text.tsx
import React71 from "react";
import { gql as gql63 } from "@apollo/client";
var __fragment41 = gql63(_templateObject62(), EGDSGraphicText.fragment, EGDSPlainText.fragment);
var DiscoveryText = function(param) {
    var className = param.className, data = param.data;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React71.createElement(EGDSPlainText, {
                className: className,
                data: data
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React71.createElement(EGDSGraphicText, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
DiscoveryText.fragment = __fragment41;
DiscoveryText.displayName = "DiscoveryText";
// ../internal/src/components/discovery-slim-card/discovery-slim-card-action.tsx
import React72 from "react";
import { gql as gql64 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkText as UitkText18 } from "uitk-react-text";
var __fragment42 = gql64(_templateObject63(), ClientSideAnalyticsFragment);
var DiscoverySlimCardAction = function(param) {
    var data = param.data;
    var resource = data.resource, accessibility = data.accessibility, target = data.target, cardActionAnalytics = data.cardActionAnalytics;
    var clickTracker = useClickTracker13();
    var onClickCapture = React72.useCallback(function() {
        clickTracker(cardActionAnalytics.referrerId, cardActionAnalytics.linkName);
    }, [
        clickTracker,
        cardActionAnalytics
    ]);
    switch(data.__typename){
        case "UILinkAction":
            return /* @__PURE__ */ React72.createElement(UitkCardLink2, null, /* @__PURE__ */ React72.createElement("a", {
                target: linkTargetMap[target],
                href: resource.value,
                "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
                onClickCapture: onClickCapture
            }, accessibility && /* @__PURE__ */ React72.createElement(UitkText18, {
                className: "is-visually-hidden"
            }, accessibility)));
        default:
            return null;
    }
};
DiscoverySlimCardAction.fragment = __fragment42;
DiscoverySlimCardAction.displayName = "DiscoverySlimCardAction";
// ../internal/src/components/discovery-slim-card/discovery-slim-card.tsx
var __fragment43 = gql65(_templateObject64(), ClientSideAnalyticsFragment, DiscoverySlimCardAction.fragment, DiscoveryText.fragment, EGDSIcon.fragment, EGDSText.fragment, UIGraphic.fragment);
var DiscoverySlimCard = function(param) {
    var data = param.data;
    var action = data.action, graphic = data.graphic, impressionTracking = data.impressionTracking, primary = data.primary, rightIcon = data.rightIcon, secondaries = data.secondaries;
    var _impressionTracking_referrerId, _impressionTracking_linkName, _ref;
    return /* @__PURE__ */ React73.createElement(IntersectionTracker9, {
        referrerId: (_impressionTracking_referrerId = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.referrerId) !== null && _impressionTracking_referrerId !== void 0 ? _impressionTracking_referrerId : "",
        linkName: (_ref = (_impressionTracking_linkName = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.linkName) !== null && _impressionTracking_linkName !== void 0 ? _impressionTracking_linkName : impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.referrerId) !== null && _ref !== void 0 ? _ref : "",
        intersectionOptions: {
            threshold: 0.5
        }
    }, /* @__PURE__ */ React73.createElement(UitkSpacing19, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React73.createElement(UitkCard10, {
        border: true
    }, action && /* @__PURE__ */ React73.createElement(DiscoverySlimCardAction, {
        data: action
    }), /* @__PURE__ */ React73.createElement(UitkCardContentSection9, null, /* @__PURE__ */ React73.createElement(UitkSpacing19, {
        margin: primary ? {
            block: "two"
        } : "unset"
    }, /* @__PURE__ */ React73.createElement(UitkLayoutFlex18, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React73.createElement(React73.Fragment, null, graphic && /* @__PURE__ */ React73.createElement(UitkSpacing19, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React73.createElement(UIGraphic, {
        data: graphic,
        iconSizeOverride: UitkIconSize7.MEDIUM
    })))), /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem12, {
        grow: 1
    }, /* @__PURE__ */ React73.createElement("div", null, primary && /* @__PURE__ */ React73.createElement(UitkHeading3, null, primary), secondaries.map(function(subheading, subheadingIndex) {
        return /* @__PURE__ */ React73.createElement(DiscoveryText, {
            key: "subheading-".concat(subheadingIndex),
            data: subheading
        });
    }))), rightIcon && /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React73.createElement(EGDSIcon, {
        data: rightIcon,
        iconSizeOverride: UitkIconSize7.MEDIUM
    })))))))));
};
DiscoverySlimCard.fragment = __fragment43;
DiscoverySlimCard.displayName = "DiscoverySlimCard";
// ../internal/src/components/discovery-items-group/discovery-footer.tsx
var __fragment44 = gql66(_templateObject65(), DiscoveryFooterSection.fragment, DiscoverySlimCard.fragment);
var DiscoveryFooter = function(param) {
    var data = param.data, discoveryFooterSectionMargin = param.discoveryFooterSectionMargin, isMultiElement = param.isMultiElement;
    switch(data.__typename){
        case "DiscoveryFooterSection":
            return /* @__PURE__ */ React74.createElement(DiscoveryFooterSection, {
                data: data,
                margin: discoveryFooterSectionMargin,
                isMultiElement: isMultiElement
            });
        case "DiscoverySlimCard":
            return /* @__PURE__ */ React74.createElement(DiscoverySlimCard, {
                data: data
            });
        default:
            return null;
    }
};
DiscoveryFooter.fragment = __fragment44;
DiscoveryFooter.displayName = "DiscoveryFooter";
// ../internal/src/components/discovery-items-group/discovery-items-group.tsx
var __fragment45 = gql67(_templateObject66(), DiscoveryFooter.fragment, DiscoveryHeading.fragment, EGDSStandardLink.fragment, DiscoveryGroupContainer.fragment, ClientSideAnalyticsFragment);
var DiscoveryItemsGroup = function(param) {
    var data = param.data, cardTheme = param.cardTheme, carouselItemViewedCallback = param.carouselItemViewedCallback, withoutIntersectionTracker = param.withoutIntersectionTracker, lineOfBusiness = param.lineOfBusiness, titleProps = param.titleProps, customTitle = param.customTitle, injectedComponents = param.injectedComponents, isMultiElement = param.isMultiElement, isFirstElement = param.isFirstElement, discoveryFooterSectionMargin = param.discoveryFooterSectionMargin, layoutOptions = param.layoutOptions, onHoverChanged = param.onHoverChanged;
    var heading = data.heading, footerLink = data.footerLink, impression = data.impression, footer = data.footer;
    var _ref = impression || {}, _ref_referrerId = _ref.referrerId, referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId, _ref_linkName = _ref.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
    var isCustomCard = typeof cardTheme !== "string";
    var nextElementSpacing = isMultiElement && !isFirstElement ? {
        blockstart: "six"
    } : void 0;
    return /* @__PURE__ */ React75.createElement(IntersectionTracker10, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, /* @__PURE__ */ React75.createElement(EGDSSpacing3, {
        margin: nextElementSpacing
    }, /* @__PURE__ */ React75.createElement("div", null, customTitle ? /* @__PURE__ */ React75.createElement(EGDSHeading, _object_spread({}, titleProps), customTitle) : heading && /* @__PURE__ */ React75.createElement(DiscoveryHeading, {
        titleProps: titleProps || {
            size: 5
        },
        subTitleProps: {
            spacing: "one",
            size: 300
        },
        data: heading
    }), /* @__PURE__ */ React75.createElement(EGDSSpacing3, _object_spread({}, isCustomCard ? {
        margin: {
            blockstart: "three"
        }
    } : {}), /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(DiscoveryGroupContainer, {
        data: data,
        cardTheme: cardTheme,
        carouselItemViewedCallback: carouselItemViewedCallback,
        withoutIntersectionTracker: withoutIntersectionTracker,
        lineOfBusiness: lineOfBusiness,
        injectedComponents: injectedComponents,
        titleProps: titleProps,
        layoutOptions: layoutOptions,
        onHoverChanged: onHoverChanged
    }))), !footer && footerLink && /* @__PURE__ */ React75.createElement(EGDSSpacing3, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(EGDSStandardLink, {
        data: footerLink
    }))), footer && /* @__PURE__ */ React75.createElement(DiscoveryFooter, {
        data: footer,
        discoveryFooterSectionMargin: discoveryFooterSectionMargin,
        isMultiElement: isMultiElement
    }))));
};
DiscoveryItemsGroup.fragment = __fragment45;
DiscoveryItemsGroup.displayName = "DiscoveryItemsGroup";
// src/components/recent-activities-module/recent-activities-module.tsx
var __Query = gql68(_templateObject67(), DiscoveryItemsGroup.fragment);
var RecentActivitiesModule = function(props) {
    var _inputs_discoveryRecentActivityContext;
    var inputs = props.inputs, skipSsr = props.skipSsr, titleProps = props.titleProps, onHoverChanged = props.onHoverChanged;
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var lineOfBusiness = inputs === null || inputs === void 0 ? void 0 : (_inputs_discoveryRecentActivityContext = inputs.discoveryRecentActivityContext) === null || _inputs_discoveryRecentActivityContext === void 0 ? void 0 : _inputs_discoveryRecentActivityContext.outputLineOfBusiness;
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.recentActivitiesModule)) {
        return null;
    }
    return /* @__PURE__ */ React76.createElement(DiscoveryItemsGroup, {
        data: data.recentActivitiesModule,
        cardTheme: DiscoveryCardContentSize[inputs.contentSize],
        lineOfBusiness: lineOfBusiness,
        titleProps: titleProps,
        onHoverChanged: onHoverChanged
    });
};
RecentActivitiesModule.displayName = "sharedui-RecentActivitiesModule";
export { DiscoveryCardContentSize, DiscoveryContainerType, LineOfBusinessDomain, RecentActivitiesModule, RecentActivityType }; // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map